export default {
  languageType: "romn",
  lang: "romn",
  welcome: "Khush Amdeed",
  select_your_language: "Language select karen",
  phone_number_placeholder: "Mobile Number",
  whats_your_phone_number: "Aapka mobile number kiya hai?",
  enter_mobile_number: "Apna mobile number enter karen",
  we_will_send_you_verification_code: "Hum aapko code SMS karen gei.",
  we_have_sent_a_verification_code_to: "Hum ny verification code bhej diya hy",
  no_internet_please_login_again: "",
  timeout_message:
    "Aap ka data restore karne mein masla ho raha hai, dobara login karen",
  enter_your_verification_code: "Verification code enter karen",
  verification_code: "Verification code",
  view_report: "Report dekhein",
  business_updated_success: "Business update ho gaya",
  coming_soon: "Jald aa raha hai",
  i_didnt_get_a_code: "Mjhe code nahi mila!",
  resend_code_in: "Code dobara bhejein",
  having_trouble: "Pareshani ho rhi hy?",
  call_us: "Call karen",
  invalid_code: "Ye galat code hai",
  search_customers_by_name_or_phone_placeholder:
    "Naam ya ph # se search karen",
  add_customer_details: "Customer details add karen",
  customer_name: "Customer ka naam",
  enter_mobile_number_optional: "Customer phone number likhen (apki marzi)",
  mobile_number_optional: "Mobile Number (apki marzi)",
  enter_customer_name: "Customer ka naam enter karen",
  phone_number: "Phone number",
  mobile_number: "Customer ka phone number",
  watch_video: "Video dekhein",

  create_customer_to: "customer banayaen aur",
  to_give_udhaar: "Udhaar den",
  create_customer: "Naya customer banayein",
  how_to_add_a_new_customer: "Naya customer kaisy banayen?",
  learn_how_to_use_oscar_udhaar:
    "Oscar Udhaar istemaal krny ka tareeqa seekhen",

  save_and_exit: "Save karke exit karen",

  udhaar: "udhaar",
  accept_payment: "Cash wasool karen",
  give_udhaar: "Udhaar do",
  total: "Total",
  select_date: "Date select karen",
  udhaar_note: "Note likhen",

  balance: "Balance",
  balance_amount: "Balance",

  login: "Log In Karen",
  get_started: "Shuru karen",
  lets_get_started_for_free: "Aye Muft mein shuru karen",
  purany_reg_ko_choren: "Puranay register ko choren",
  ab_saara_hisaab_phone_pei: "Ab saara hisaab phone pai",

  enter_phone_placeholder: "Mobile number likhen",
  dont_have_account:
    "Kiya apka account nahi bana hua hai? Abhe apna account banayen",

  // Give UDHAAR
  please_enter_correct_amount: "Sahi amount darj karen",
  give: "Aapne Diye",
  UDHAAR: "Credit",
  accept: "Wasool karen",
  PAYMENT: "Paisy",
  add_payment: "Cash Add Karen",

  advance: "Advance",

  net_udhaar: "Net Udhaar",
  net_advance: "Net Advance",
  udhaar_due: "Udhaar Due",
  advance_payment: "Advance payment",

  total_udhaar_given: "Ab tak diya hua Udhaar",
  total_advance: "Total advance",
  total_udhaar: "Total Udhaar",
  share_oscar_udhaar_with:
    "Udhaar app share karen apny doston aur rishtydaaro ky sath",
  are_you_sure_you_want_to_delete_image: "Kya aap waqai tasveer ko delete karna chahte hain?",
  are_you_sure_you_want_to_exit: "Kia aap waqai exit karna chahte hain?",

  //credithistory screen
  date_and_time: "Date aur time",
  udhaars: "Udhaar",
  udhaar_book: "Udhaar Book",
  payment: "Cash",
  payments: "Paisy",
  balance_amount_credit_screen: "Balance",
  sms: "SMS",
  reminder: "Reminder",
  please_install_watsapp: "WhatsApp install karen",

  //todaykhata screen
  as_of_today: "Ab tak",
  total_customer: "Customers",
  net_balance: "Net Balance",

  //sharing screen
  share_on_whatsapp: "Whatsapp per share karen",
  more_options: "Mazeed options",

  //Drawer Component
  home: "Home",
  language: "Language",
  logout: "Log out karen",
  urdu: "Urdu",
  english: "English",
  business: "Business",
  profile: "Profile",
  settings: "Settings",
  business_card: "Business Card",

  //filter options text
  sort_by_atoz: "A Se Z Tak Sort Karen",
  sort_by_ztoa: "Z Se A Tak Sort Karen",
  balance_due: "baqaiyah balance",

  //note modal
  note: "Note",

  promotions: "scheme",
  promotions_are_not_available_at_the_moment: "Es waqt koi scheme nahi hai",
  customers_not_found: "Customer nahi mila",
  next: "Agla",
  are_you_sure_you_want_to_logout: "Kiya aap log out hona chahty hein?",
  internet_is_required_for_sign_in:
    "Sign in krny ky liye Internet connection chaye",
  internet_is_required_for_sign_up: "Internet connection chaye",
  add_your_first_entry: "Phela customer banayen",
  mobile_no_is_already_registered: "Ye mobile number phele se registered hai",
  customer_updated_successfully: "Customer details update ho gayi hain.",
  transaction_updated_successfully: "Transaction Kamyabi Se Update Ho Gayi",
  transaction_added_successfully: "Transaction kamyabi se add ho gayi",
  no_customer_found_by_name: "Es naam se koi customer nahi hai",
  woulud_you_like: "Kia aap shaamil krna chaye gy",
  add_user: "User Add Karen",
  added_on: "Entry date",
  user_not_found_create_an_account:
    "Mazraat ye number registered nahi hy. Apna account banayen",
  verification_code_has_been_sent: "Verification code bhej diya hai",
  this_number_associate_with_another_customer:
    "Ye mobile number phele se registered hai",
  no_customer_found: "Koi customer nahi hai, Add karen",

  //edit profile
  business_name: "Aapke business ka naam",
  business_name_label: "Aapke business ka naam",
  business_name_placeholder: "Aapke business ka naam enter karen",
  update: "Update karen",
  business_name_cannot_be_empty: "Business ka naam khali nahi chor sakty",
  free_sms_bheje: "Muft SMS bhejne ky liye customer ka mobile number dalen",
  update_customer: "Customer Update Karen",
  business_category_is_required: "Business ka type zaroori hai",
  business_category_label: "Business ki category",

  //view_customer_profile
  customerprofileheading: "Customer Profile",
  do_you_want_to_delete: "Kia aap customer delete karna chahte hain?",
  yes: "Haan",
  cancel: "Cancel karen",
  no: "Nahi",
  delete_customer: "Customer delete karen",
  delete_supplier: "Supplier delete karen",
  // customer_name: "Customer ka naam",
  customer_number: "Customer Number",
  transaction_sms: "Transaction SMS",

  //creatcustomer screen
  create_customertitle: "Customer add karen",

  //Account Statment Screen
  advance_acc: "Advance",
  due_acc: "Due",
  customer: "Customer",
  transactions: "Transactions",
  transactions_type: "Transaction ki qisam",
  account_statement: "Account statement",
  transaction_statement: "Transaction statement",
  manage_your_ledger:
    "Waqt bachany aur aamdani me izaafy ky liye apny hisab kitaab ko Udhaar app me mehfooz karen",
  date_select: "Date select karen",
  today: "Aaj",
  yesterday: "Kal",
  last_seven_days: "Pichle 7 din",
  last_thirty_days: "Pichle 30 din",
  date_acc: "Date",
  filter_options: [
    "Today",
    "Yesterday",
    "Last 7 Days",
    "Last 30 Days",
    "Last Month",
    "All Time",
    "Cancel",
  ],

  //Edit Transactions Screen
  udhaar_amount: "Udhaar Amount",
  advance_amount: "Advance Amount",
  payment_amount: "Payment Amount",
  edit_transaction: "Transaction update karen",
  enter_amount_trans: "Amount Likhein",
  add_note_trans: "Item ka naam likhen",
  do_you_want_to_delete_transaction:
    "Kia aap ye transaction khatam krna chahty hein?",
  customer_will_receive_SMS:
    " Customer ko edit ki hui maloomat ky hisab se SMS jaye ga",
  delete_transaction: "Transaction Delete Karen",
  transaction_deleted: "Transaction Delete Ho Gayi",
  save: "Save karen",

  //backup screen
  backup: "Backup",
  oscar_udhaar_backs_up_your_data_twice_a_day_automatically:
    "Udhaar app khud hi Data ko mehfooz karta rehta hai ta ky apka data mehfooz rhy",
  in_case_app:
    "Agar Udhaar app delete ho jati hai tou udhaar app ko dobar download karen aur apna mobile number se login kar ky sara data wapis hasil karen",
  easy_safe_reliable: "Asaan, mehfooz, bharosemand",
  last_backup_time: "Pichli backup ka waqt",
  backup_success: "Backup Kamyab",
  backup_now: "Abhi backup karen",
  backup_not_successful: "Backup Kamyab Nahi Hua",
  data_not_backup: "Aap ka data poori tarah backup nahi hua. Apna data backup karen.",
  uploading_your_backup_please_wait: "Aap ka data backup ho raha hai",
  restoring_your_backup_please_wait: "Apka data restore ho raha hai",
  uploading: "Upload ho raha hai",
  restoring: "Restore ho raha hai",

  // customer list
  name_can_not_be_empty: "Naam khali nahi ho sakta",
  contact_list: "Contact List",
  add_new_customer: "Naya customer banayen",
  contacts: "Contacts",

  // Business Card
  business_category: "Aapke business ka type",
  address: "Address",
  enter_address_optional: "Address Likhen (Ikhtiyari)",
  other_info: "Mazeed maloomat",
  ohter_info_placeholder: "Email, Taaruf, Naam (Ikhtiyari)",
  email: "Email",
  email_placeholder_optional: "Email Likhen (Ikhtiyari)",
  about_us: "Hamare baray mein",
  about_us_placeholder_optional: "Hamare Baray Mein Likhen (Ikhtiyari)",
  contact_name: "Contact ka naam",
  contact_name_placeholder_optional: "Contact Ka Naam Likhen (Ikhtiyari)",
  create_and_share_business_card: "Apna business card banayen aur share karen",
  business_name_is_required: "Business ka naam khali nahi chor sakty",
  share_business_card: "Business card share karen",
  phone_number_is_required: "Mobile number zarori hai",
  address_is_required: "Address zarori hai",
  email_is_required: "Email zarori hai",
  about_us_is_required: "maloomat zarori hai",
  contact_name_is_required: "Naam zarori hai",
  email_business_card: "Email :",
  address_business_card: "Address :",
  more_options_business_card: "mazeed options",
  add_business_name: "Business ka naam likhen",
  number_of_customers: "Customers ki tadad",
  download: "Download karen",
  select_mobile_network_placeholder:
    "Ported numbers ky liye OTP hasil krne ky liye",
  select_mobile_network_placeholder2:
    "Ported numbers ky liye sahi network select karen",
  mobile_network: "Mobile network",
  phone_number_format: "Mobile number es tarah hona chaye 03001234567",
  phone_number_length: "Mobile number 11 digits ka hona chaye",
  network_required: "Mobile network ki zarorat hai",
  telenor: "Telenor",
  jazz: "Jazz",
  ufone: "Ufone",
  zong: "Zong",
  scom: "Scom",
  select_business_category: "Apkai business ka type kia hai",
  camera: "Camera",
  gallery: "Gallery",
  delete: "Delete karen",
  photo_added: "Photo add ho gae hy",
  please_select_your_business_category: "Aapke business ka type select karen",
  upload_from: "Upload karen",
  take_photo: "Picture len",
  with_camera: "Camera se",
  internet_connection_is_required: "Internet Connection zarori hy",
  no_internet: "Internet Connection nahi hy",
  internet_to_view_image: "Picture daikhny ky liye Internet chaye",
  internet_to_upload_image: "Picture ko upload krny ky liye Internet chaye",
  udhaar_balance: "Udhaar Balance",
  advance_balance: "Advance Balance",
  ledger_secured: "Khata mehfooz aur theek hai",
  friends_at_udhaar: "- Udhaar app per apky dost",
  transaction_saved: "Transaction Save ho gae",
  message_sent: "Message bhej dia gya hy",
  payment_reminder: "Payment ki yaad dahani",
  eid_card: "Eid Card",
  send_eid_card: "Eid Card bhejein",
  share_eid_card: "Eid Card share karen",
  create_share_eid_card: "Eid Card banaye aur share karen",
  greeting_salutation: "Salam",
  greeting_placeholder: "Salam karen",
  greeting_required: "Salam kehna zarori hai",
  eid_message: "Eid ka paigham",
  eid_message_placeholder: "Eid ka paigham likhen",
  message_required: "Eid ka paigham zarori hai",
  signature: "Signature",
  signature_placeholder: "SIGNATURE karen",
  signature_required: "SIGNATURE zarori hai",
  send_card_to_customers: "Apny customer ko muft eid card bhejen",
  greeting_message_requried: "Salam karna aur paigham dena zarori hai",
  set_collection_date: "Udhaar wapis lene ki tareekh likhen",
  collection_date: "Wasooli tareekh",
  select_collection_date: "Udhaar wapis lene ki tareekh likhen",
  collection_sub_heading: "SMS alert apki dali hui tareekh ko bheja jaye ga ",
  collection_sub_heading_2: "SMS alert apki dali hui tareekh ko bheja jaye ga",
  clear: "Clear karen",
  collection_due: "Collection baqi",
  sms_will_be_sent: "Automatic SMS alert bhej diya jaye ga",
  remind: "Yaad dilayen",
  collection: "Collection",
  payment_due_today: "Payment aaj due hai",
  past_due: "Waqt guzar gaya",
  five_days: "5 Din",
  ten_days: "10 Din",
  fifteen_days: "15 Din",
  next_month: "Agla mahina",
  request_payment: "Payment wapis mangain",
  send_via_whatsapp: "WhatsApp se bhejein",
  send_via_sms: "SMS se bhejein",
  call_customer: "Customer ko call karen",
  independence_day_tag:
    "2000 rupee jeetne ky liye 14 august ko video ko share karen",
  independence_day_video: "Azadi Day Video",
  create_share_independence_video:
    "Independence day pe video banaye aur share karen",
  share_facebook: "Facebook pe share karen",
  please_install_facebook: "Meharbani kar ky facebook install karen",
  request_dues: "Baqaya Mangen",
  restore_error: "Apka data sahi se restore nahi ho ska dobara login karen",
  record_video_message: "Video record karen",
  record_video: "Video record karen",
  video_message_1: "Apne doston ke liye azadi ka",
  video_message_2: "message record karain",
  video_sub_message: "20-40 sec ki video banaen or jeeten Rs 2,000",
  follow_these_steps: "Ye tareeqy ko follow karen",
  step_1: "Video apni timeline pe share kerain",
  step_2: "#tags add kerain #AzadiStar #UdhaarApp #Azadi2020",
  step_3: "Apne friends se share karwain",
  step_4: "Sab se ziada shares ko milega Rs 2,000 Azadi price",
  step_5: "Apni post comments main share kerain",
  download_report: "Report download karen",
  send_free_sms: "Muft SMS Bhejein",
  aap_ne: "Aap ne",
  liye_hain: "liye hain",
  info: "Info",
  send_sms: "SMS bhejein",
  sedf_sms2: "SMS bhejein",
  not_now: "Abhi nahi",
  quotes: [
    "Tough is your middle name",
    "Let's get it done",
    "Nothing you can't handle",
    "You can do it and you know it",
    "Flex your 'can do' muscle",
    "Impress yourself today",
    "Seize the day",
    "Buckle down and push forth!",
    "Don't try harder. Do harder!",
    "March forward!",
    "Keep your chin up",
  ],
  trusted_by: "5.1M+ karaobario ka bharosa",
  by_continuing: "Ap hamary terms aur conditions se itefaaq krty hn",
  terms_of_services: "Terms of Services",
  privacy_policy: "Privacy Policy",
  other_category: "Doosri category",
  enter_other_category: "Aapke business ki category enter karen",
  add_customer: "Customer add karen",
  send_via: "bhejen",
  whatsapp: "Whatsapp",
  report: "Report",
  customer_statement: "Customer",
  ledger_ready: "Khata set kar diya hai",
  have_a_wonderful_day: "Inshallah, aaj ka din zabardast hoga",
  having_trouble_contact_us: "Ap ko pareshani ho rhi hy? Call karen humein",
  loading_your_data: "Mehfooz data transmission jaari hai",
  data_loaded: "Data aa chuka hy. Apky hisab kitaab ko set kia ja rha hy",
  awsome_phone_verified: "Zabardast! Apka phone # verify ho gaya",
  businesss_will_be_displayed:
    "Jab chahen, apne customer ko free SMS send karen",
  logged_in_from_another_device: "Apka session expire hogaya hai",
  device_has_been_logged_out:
    "Apka session expire hogaya hai, Udhaar app use karnai k liye phrsai login karain",
  use_here: "Yahan istemaal karen",
  grow_business_with_udhaar: "Udhaar app ky zariye apna karoobar barhayen",
  enter_khata_amount: "Khaty ky paisy dalen",
  share_details_with_sms: "Details bhejen must SMS ky zariye",
  play_and_win_cash: " Quiz khelen aur inaam jeeten.",
  play_now: "Abhi khelein",
  udhaar_quiz: "Udhaar Quiz",
  play_and_earn_gifts: "khelen aur inaam payen",
  how_to_play: "khelen aur 1000 rupee jeeten",
  trivia_instructons_1: "Sub sawalon ke sahi jawab dain",
  trivia_instructons_2: "Quiz ka time hoga 60 seconds",
  trivia_instructons_3: "Har hafte Rs 1000 jeeten",
  start_quiz: "Quiz shuru karen",
  quiz_timings: "Har roz Quiz ka time 12PM - 4PM",
  help: "Madad",
  question: "Sawal",
  congrats_you_won: "Mubarak ho. Ap jeet gye",
  sorry_you_didnt_win: "Mazraat aap jeet nahi skey",
  missed_by_1: "Afsos 1 galat jawab dene se reh gye",
  lucky_draw_will_be_announced:
    "Lucky draw me jeetne waly ka naam 4 PM ko kiya jaye ga",
  share_on_facebook_to_win:
    "Jeetne ky imkaanat barhanay ky liye facebook pe share karen",
  IA_next_time: "Kal agley quiz me shamil ho kar jeetne ki khoshish karen",
  new_quiz_tomorrow: "Agla quiz kal shuru hoga",
  share: "Share karen",
  back_to_home: "Home par wapis jayein",
  contact_us: "Hum se rabta karen",
  terms_and_conditions: "Terms Aur Conditions",
  trivia_term_1: "1. Ye quiz Oscar ki janib se organise kia gaya hai",
  trivia_term_2:
    "2. Quiz mai enter hone wale participants ke liye in tamam terms or conditions ko follow karna lazmi hoga",
  trivia_term_3: "3. Quiz mai entry ke koi charges nahi hain",
  trivia_term_4: "4. Quiz dopeher 12 se sham 4 tak khela ja sakta hai",
  trivia_term_5:
    "5. Entries terms or conditions ke mutabiq na huin, to accept nahi hongi",
  trivia_term_6: "6. Na-mukamal ya bad-unwaan entries bhe accept nahi hongi",
  trivia_term_7:
    "7. Quiz ka new round every week Friday ko start hoga or thursday par end hoga",
  trivia_term_8: "8. Winners weekly basis par Friday ko announce kiye jayenge",
  trivia_term_9:
    "9. Tamam log jo Udhaar app par registered hain, quiz mai hissa le sakenge",
  quiz_submit_karnai_ke_baad: "Quiz submit karne ke baad:",
  after_submit_1: "1. Jeetne wale participant ka inaam Rs 1000 hai",
  after_submit_2:
    "2. Quiz mai daily 3 sawalon ke jawab dene par 1 entry count hogi. Jis participant ke 3 jawab durust honge, sirf wohi dusre round (qurandazi) mai shamil ho sakenge",
  after_submit_3:
    "3. Week mai jitni zyada correct entries, utne zyada jeetne ke chances",
  after_submit_4: "\"4. Winner decide hone ke bad, announcement se pehle, participant ye details share karenge:\n        a. Name\n        b. Contact #\n        c. Postal Address\n        d. NIC #\n        e. Photograph (Optional)",
  after_submit_5:
    "5. Winner announcement ke bad prize 3-4 working days mai deliver hoga",
  after_submit_6:
    "6. Kisi ghair-yakeeni surat-e-hal ya tanaze ki surat mai Oscar ka decision final hoga, jis par kisi tarah ki discussion nahi ki jaegi",
  after_submit_7:
    "7. Kisi bhe waja ke tehet, Oscar quiz cancel ya postpone kar sakta hai. Prize money main changes bhi ki ja sakti hain. Oscar in changes ki itala dene ka paband nahi hoga",
  after_submit_8:
    "8. Oscar ke pas right hai ke wo prize money cancel karde agar inaam mai di gae rakam ka istamal kisi unethical ya illegal activity ke lye kia jaraha hai",
  after_submit_9:
    "9. Quiz mai entry ke sath ap ye raza-mandi zahir kar rahe hain ke ap ka name or city Udhaar ke social channels par share kia jaega, winner announce hone ki surat mai",
  after_submit_10:
    "10. Oscar ke pas right hai ke wo terms or conditions mai changes kar sakte hain bina kisi prior notice ke",
  do_you_want_to_exit: "kiya aap waqai band krna chahty hn??",
  you_wont_be_able_to_play:
    "Aap aaj dobara nahi khel sken gy. Agla quiz kal shuru hoga",
  data_not_backedup:
    "Data ka backup nahi hua. Backup ke liye yahan click karen",
  click_here: "Yahan click karen",
  to_backup_your_data: "Data backup ke liye, yahan click karen",
  backup_successful: "Backup Kamyaab",
  select_account_statement_filter: "Account statement filter select karen",
  selected_filter: "Chuna gaya filter: ",
  custom: "Custom",
  select_upcoming_date: "Aney wali tareekh dalen",
  filter_error: "filter theek nahi hai",
  dont_know: "Maloom nahi",
  filter: "Filter",
  no_contact_permission_1:
    "Kiya aap apny phonebook se contacts lana chahty hein?",
  no_contact_permission_2:
    "Udhaar app ko ijaazat den ky woh apky contacts la skey",
  no_contact_permission_3: "Ijaazat dene ky  liye yahan click karen",
  collection_date_heading: "Wasooli tareekh",
  pending: "Pending",
  upcoming: "Aane wala",
  settled: "Settled",
  sort_by: "Sort karen",
  filter_name_az: "Naam (A-Z)",
  filter_amount: "Amount",
  filter_amount_desc: "Amount ziada se kam",
  filter_least_recent: "Sab se purana",
  filter_most_recent: "Sab se naya",
  filter_due_date: "Akhri tareekh",
  transaction_type: "Transaction ki qism",
  default: "Phele se set hua wa",
  apply: "Apply karen",
  all: "Sab",
  loading_your_contacts: "Mobil number laye ja rhy hn",
  enter_pin_to_use_udhaar: "Pin enter karen",
  enter_pin_to_remove_pin: "Pin remove karen",
  set_new_udhaar_app_pin: "New pin set karen",
  pin_did_not_match: "PIN code match nahi hai",
  pin_lock_has_been_removed: "Pin lock hat gya hy",
  confirm_udhaar_app_pin: "Dobara pin dalen",
  enter_pin: "Pin daalein",
  enter_pin_here: "Yahan PIN dalen",
  udhaar_security: "Udhaar Security",
  touch_sensor: "Touch Sensor",
  you_must_set_a_pin_first: "Apko phele PIN set krna hoga",
  remove_biometric: "Biometric hata den",
  pincode: "PIN code",
  set_a_4_digit_pincode: "4 digits ka code dalen",
  enable: "Enable karen",
  face_id: "Face ID",
  touch_id: "Touch ID",
  biometrics: "Biometrics",
  app_lock: "App Lock",
  udhaar_app_secure_lock: "Udhaar App ka mehfooz lock",
  please_use_fingerprint_to_unlock_app:
    "Fingerprint use karen app ko use krny ky liye",
  show_finger: "Finger lagen",
  touch_the_fingerprint_sensor: "Fingerprint sensor ko touch karen",
  wrong_pin: "Galat Pin",
  attempts_remaining: "koshishein baqi",
  reset_pin: "PIN reset karen",
  forgot_pin: "PIN bhool gaye?",
  your_udhaar_app_account_is_locked: "Udhaar App locked hy",
  tap_here_to_use_finger_print_login: "Yahan fingerprint lagayen",
  commission_earned: "Hasil kia hua comission",
  customer_n: "Customer number",
  commission: "Commission",
  wallet: "Wallet",
  give_easy_load: "Easyload do",
  choose_network: "Network choose kro",
  earned: "Kaamai",
  add_balance: "Balance dalo",
  easy_load_by_udhaar: "Easyload Udhaar app ky zariye",
  earn_commission_with_udhaar:
    "Udhaar app se easyload krne pe 2.5% comission hasil karen",
  easy_load_in_3_steps: "Easyload ky 3 asan tareeqy",
  add_balance_to_wallet: "Walet mai paisy dalen",
  enter_customer_number: "Customer ka mobile number dalen",
  give_easy_load_earn_commission: "Easyload karen aur comission hasil karen",
  addBalance: "Balance dalo",
  add_money_to_wallet: "Walet mai paisy dalen",
  easy_paisa: "Easypaisa",
  jazz_cash: "JazzCash",
  ubl: "UBL",
  hbl: "HBL",
  easy_paisa_account: "Easypaisa Account",
  jazz_cash_account: "JazzCash Account",
  ubl_account: "UBL Account",
  hbl_account: "HBL Account",
  account: "Account",
  mobile_number_label: "Mobile Number",
  number_verification_note:
    "Number ki tasdeeq ky liye verification code bheja jaye ga",
  amount_required: "Paiso ki zarorat hai",
  easypaisa_pin_confirmation: "Easypaisa Pin Confirmation",
  jazzcash_pin_confirmation: "JazzCash PIN Confirmation",
  ubl_pin_confirmation: "UBL Pin Confirmation",
  hbl_pin_confirmation: "HBL Pin Confirmation",
  pin_confirmation: "Pin Confirmation",
  enter_otp_code: "OTP dalen",
  submit: "Jama karen",
  has_been_added_to_wallet: "Aap ky walet me paisy daal diye gn hn",
  you_can_use_the_balance:
    "Ab ap recharge aur paisy wapis krne ky liye walet se paisy istemaal kr skty hn",
  edit_information: "Maloomat me tabdeeli",
  earn_money: "Paisa kamao",
  b_card: "B.Card",
  play_quiz: "Quiz khelen",
  easy_load: "Easy Load",
  prepaid: "Prepaid",
  postpaid: "Postpaid",
  device: "Device",
  no_packages_available: "packages abhe dasteyaab nahi hy",
  recharge_details: "Rechage ki details daikhen",
  network: "Network",
  phone_number_small: "Mobile Number",
  feeAndTax: "Fee & Tax",
  no_charges: "Koi Charges Nahi",
  total_amount: "Total Amount",
  pay_now: "ABHI PAY KAREN",
  easyload_successful: "Easyload ho gya",
  phoneN: "Mobile number",
  sms_has_been_sent: "Uper waly number pe SMS bhej diya gya hai",
  edit_share_whatsapp: "Tabdeeli karen aur whatsapp pe share karen",
  edit: "Edit",
  marketing_in_easy_steps: "Marketing karen 3 asan marhalo me",
  choose_your_details: "Details me se choose karen",
  enter_your_details: "Aap apni details den",
  share_details_whatsapp: "Whatsapp per details share karen",
  add_first_banner: "Apna phela banner lagen",
  offer: "50% OFF OFFER",
  best_quality_products: "Behtreen quality ki product woh bhe munasib paiso me",
  shop_from: "Yahan Se Shop Karen",
  my_shop: "Meri Dukaan",
  enter_heading: "Heading dalen",
  enter_description: "Details dalen",
  description_placeholder: "Best quality ki products",
  enter_shope_name: "Dukaan ka naam likhen",
  share_store_banner: "Share karen store banner",
  edit_template: "Design mein changes karen",
  invalid_amount: "galat paisy",
  get_more_business: "Free marketing kar ky mazeed business ko barhain",
  select_your_marketing_banner: "Apny marketing ky liye banner choose karen",
  add_promotion_or_other_special_message:
    "Promotions Ya koi aur special message dalen",
  share_with_friends_and_customers: "Dosto aur customer ky sath share karen",
  marketing: "Marketing",
  more: "Mazeed",
  new: "Naya",
  to_take: "Aapko Milenge",
  to_give: "Aapko dene hain",
  total_taken: "Aapko Mile",
  total_given: "Aapne Diye",
  entry: "Entry",
  entries: "Entries",
  given: "Aapne Diye",
  taken: "Aapko Mile",
  give_: "Aapne Diye",
  take: "Aapko Mile",
  your_business: "Apka business",
  create_new_business: "New business banayen",
  switching_to_business: "{name} par switch ho rahe hain",
  add_new_business: "New business banayen",
  select_start_date: "Start date select karen",
  select_end_date: "End date select karen",
  transaction: "Transaction",
  add_your_first_traansaction: "First transaction karen",
  setup_your_invoice_transaction_with_us: "Invoice transaction setup karen",
  loading: "Loading Ho Rahi Hai",
  active_filter: "Active Filters",
  new_transaction: "Nayi Transaction",
  buy: "Khareedein",
  sell: "Bechein",
  add_business: "BUSINESS ADD KARAIN",
  logout_backup: "BACKUP",
  logout_anyway: "PHIR BHI LOGOUT KAREN",
  waiting_otp: "Apko code SMS kar diya hai",
  enter_code: "4 digit code enter karen",
  call_me: "Call karen",
  verify: "Verify Karen",
  have_you_change_mobile_network: "Apne apna mobile network change kia hai?",
  select_network_to_rec_otp: "Apna current network select karen",
  waiting_for_code: "Apko code SMS kar diya hai",
  otp_call: "OTP code call pe bta diya jaye ga",
  add_customer_and_maintain_udhaar:
    "Customer add karen aur khata maintain karen. Free payment reminder. Wasooli 3x tez.",
  trusted_b_over: "5.1M+ businesses ka trust ",
  trusted_b: "5.1M+ businesses ka trust ",
  stat_using_udhaar_app: "UDHAAR BOOK USE KAREN",
  dont_ask: "Dobara Na Poochein",
  // add_customer_and_maintain_udhaar: 'Customer add karen aur apna khata banaen automatic. Wasooli 3X tez.',
  // manage_your_business: 'Apne khata aur business ko manage karen. reminder bhejein aur payments hasil karen. 100% Free.',
  manage_your_business: "Free reminder sei khata wasooli 3x tez. 100% Free.",
  // trusted_b_over: '5.1M+ businesses ka trust',
  // stat_using_udhaar_app: 'UDHAAR BOOK USE KAREN',
  // dont_ask: "Don't ask again",
  manage_daily_cash_transactions:
    "Daily cash, sales and expenses manage karen",
  invoice_descp_1: "Balance in hand ko sales aur expense sai compare karain",
  invoice_descp_2: "Custom bills & invoices banayen details ky sath",
  invoice_descp_3: "Monthly & daily reports download karen",
  cash_in: "Cash in",
  cash_out: "Cash out",
  add_item: "Item add karen",
  change_date: "Tareekh Change Karen",
  add_photo: "Photo Add Karen",
  add_note: "Note Add Karen",
  select_invoice_date: "Invoice Ki Tareekh Select Karen",
  reset: "Reset Karen",
  enter_item_name: "Item Ka Naam Enter Karen",
  enter_item_placeholder: "Jaise Mango",
  item_name_required: "Item ka naam zarorri hy",
  add_another_item: "Mazeed item dalen",
  invalid_quantity: "Galat quantity",
  customer_list: "Customer List",
  select_invoice_status: "Invoice status select karen",
  paid: "Paid",
  not_paid: "Paid Nahi",
  select_payment_method: "Payment Method Select Karen",
  cash: "Cash",
  bank: "Bank",
  add_your_own: "Apna Add Karen",
  payment_method: "Payment method",
  change_method: "Method Change Karen",
  // add_your_own: 'Add your own',
  invoice: "Invoice",
  verified_by: "Verified by",
  item_details: "Item Ki Details",
  // total_amount: 'Total amount',
  made_with: "Bana hai ",
  in: "In",
  out: "Out",
  cash_out_amount: "Cash Out Ki Amount",
  cash_in_amount: "Cash In Ki Amount",
  cash_in_placeholder: "Cash In Amount Enter Karen",
  cash_out_placeholder: "Cash Out Amount Enter Karen",
  take_a_picture: "Photo Khenchein",
  upload_from_gallery: "Gallery Se Upload Karen",
  take_photo_with_camera: "Camera Se Photo Khenchein",
  more_items: "Mazeed Items",
  transaction_successful: "Transaction Kamyab",
  cash_on_hand: "Hath Mein Cash",
  cashbook: "Cash Book",
  sales: "Sales",
  expense: "Expense",
  bill: "Bill",
  add_bill_to_contact: "Contact Ko Bill Add Karen",
  automatically_add_credit_to_contact:
    "Kia ap es contact k khatai mai yeh entry add karna chahtai hai?",
  // no: 'No',
  quick_entry: "Fori Entry",
  itemized_entry: "Item Wise Entry",
  // transaction_type: 'Transaction Type',
  invoice_can_be_edited_cashbook:
    "Invoice sirf cashbook se edit / delete ho sakti hy",
  delete_associated_invoices: "Related Invoices Delete Karen",
  do_you_want_to_delete_invoice:
    "Kia ap es contact se associate invoice delete karna chahty hein?",
  todays_balance: "Aaj Ka Balance",
  delete_entry: "Entry Delete Karen",
  credit_added_to_contact: "Es contact ky andar paisy daal diye gye hn",
  contact_via_whatsapp: "Whatsapp ky zariye contact karen",
  credit: "Credit",
  add_contact: "Contact Add Karen",
  share_your_promotions: "Promotions share karen",
  edit_sales: "Sales Edit Karen",
  edit_expense: "Expense Edit Karen",
  play_tutorial: "Video Dekhein",
  see_help_tutorial: "Tutorial ki video",
  manage_cash_sale: "Sales aur expenses ko manage karen.",
  send_free_invoices: "Zabardast invoices banaen. 100% Free.",
  send_free_promotions: "Muft sms bhejen",
  send_free_promotions_to_customer:
    "Customers ko Muft sms bhejen aur sales barhaen",
  share_udhaar_app: "Udhaar app dosto ky sath share karen",
  earn_upto: "45000 rupee tak mahana kamayen",
  you_will_get:
    "Apko har dost ky 20 rupee milen gy jo 2 alag din 2 transaction krty hein",
  contact_customer: "Customer Ko Contact Karen",
  sell_online: "Online Bechein",
  latest_transaction: "Sab Se Nayi",
  reminder1: "Reminder",
  collect_today: "Aj paisy lyen",
  pending_collection: "Paisy lene baqi hen",
  collect_on: "lene hn",
  send_reminder: "Reminder bhejen",
  set_new_date: "Nayi tareekh set karen",
  active_filter2: "Active Filter",
  collection_set_successfully: "Collection Date set hochuki hai",
  total_earning: "Total Kamai",
  not_earned_money:
    "Ap ny koi paisy nahi kamaye hn, Apne dosto ky sath share karen aur paisy kamayen",
  app_installed: "App install ho gayi",
  two_entries_done: "2 enteries ho chuki hen",
  rs10_earned: "10 Rupee kamayee hen",
  add_phone_number: "Mobile number likhen",
  add_phone_to_set_date:
    "Collection date set karny ky liye mobile number dalen",
  remind_with_whatsapp: "Whatsapp ky zariye yaad dilayen",
  remind_with_sms: "SMS ky zariye yaad dilayen",
  no_pending_collections: "Mubarak! Koi pending collection nae hai",
  no_collection_for_today:
    "Aj ki koi collection nae hai, pending mai jaen aur collection set karwain jald adaegi k liye",
  remove_colletion_from_selected:
    "collection date select kiye hue contact se hata di gae hy",
  collection_removed_successfully: "collection data hata di gae hy",
  no_collection_today_line_1: "Aj ki koi collection nae hai, ",
  no_collection_today_line_2:
    "mai jaen aur collection set karwain jald adaegi k liye",
  no_collection_upcoming_line_1: "Anai wali koi collection nae hai, ",
  turn_off_invoice_for_all:
    "Kia aap future ky sarey len den ki apny ap janey wali raseeden band karna chahty hein?",
  billbook: "Bill Book",
  search_item: "Item Search Karen",
  items_list: "Items List",
  item_stock: "Item Stock",
  enter_item_stock: "Item ka stock dalen",
  selling_price: "Selling Price",
  enter_selling_price: "Selling Price Enter Karen",
  cost_price: "Cost Price",
  enter_cost_price: "Cost likhen",
  add_price: "Price Add Karen",
  edit_item: "Item Edit Karen",
  low_stock: "Low stock",
  bill_details: "Bill Ki Details",
  item: "Item",
  items: "Items",
  cash_added_to_contact: "Cash ko cashbook me daal diya gya hy",
  net_profit: "Net profit",
  all_time: "Hamesha",
  this_week: "Is Hafte",
  this_month: "Is Mahine",
  // bill: 'Bill',
  bill_can_be_edited_cashbook:
    "Bills sirf billbook me edit ya delete ho sakty hn",
  add_items: "Items Add Karen",
  select_items: "Items Select Karen",
  no_items_added_recently: "Naya koi item nahi dala hy",
  current_bill: "Mojooda Bill",
  press_the_mark_to_add: "Nahi hy ya phele se nahi hy",
  item_already_in_bill: "item phele hi bill me daal diya gaya tha",
  item_with_this_name_exists:
    "es naam se item phele hi hy, dusry naam se item banayen",
  sales_amount: "Sale Amount",
  sales_amount_placeholder: "Sales Amount Enter Karen",
  cost_amount: "Cost Amount",
  cost_amount_label: "Cost Amount (apki marzi)",
  cost_amount_placeholder: "Cost amount daalen",
  optional_information: "Mazeed maloomat",
  your_loss: "Apka nuqsan",
  your_profit: "Aapka Munafa",
  items_added: "Items daal diya gya hy",
  remove: "hata den",
  enter_note_terms: "Note dalen",
  select_payment_information_optional: "Payment ki maloomat dalen",
  has_the_bill_paid: "Kia bill pay hua hy?",
  select_bank: "Bank Select Karen",
  select_wallet: "Wallet Select Karen",
  total_Entries: "Total 7 Entries",
  start_date: "Shuru Ki Tareekh",
  end_date: "Aakhri Tareekh",
  save_items: "Items Save Karen",
  add_an_item: "Item Add Karen",
  bill_items: "Bill Items",
  share_bill: "Bill Share Karen",
  do_not_share_bill: "Bill share nahi karen",
  add_details: "Details Add Karen",
  optional: "(ikhtiyari)",
  going_back_will_discard_transaction:
    "Wapis janey se aap ka likha hua khatam ho jae ga",
  go_back: "Wapis jao",
  cashbook_report: "Cashbook Report",
  profit: "Munafa",
  total_sales: "Total sales",
  total_expense: "Total expenses",
  select_report_type: "Report ki qisam muntakhib karen",
  download_pdf: "PDF Download Karen",
  bill_pdf_processing: "Bill ki PDF tayyar ho rahi hai...",
  bill_pdf_unavailable: "Bill ki PDF abhi dastiyab nahi hai",
  detailed_report: "Tamam detail ky sath mukamal report",
  summary_report: "Din ki report",
  other_category_label: "Other category ka naam likhein",
  recharge: "Recharge",
  connect_your_account: "Apna account connect karen",
  earn_upto_3_commission: "Kamaen Up To",
  // commission: 'commission',
  on_easy_load: "EasyLoad Par",
  add_balance_for_easyload: "EasyLoad Ke Liye Balance Add Karen",
  invoice_book: "Invoice Book",
  purchase_invoice: "Purchase Invoice",
  purchase_bill: "Purchase bill",
  purchase_report: "Purchase report",
  now_you_can_collect_payment_digitally_with_udhaar_app:
    "Ab aap udhaar app ky zariye digital tareqqe se udhaar ki adaiygi kar skty hen",
  congratulations: "Mubarak ho!",
  did_not_receive_deposit_try_again: "Deposit Nahi Mila? Dobara Koshish Karen",
  verify_account: "Account ki tasdeeq karen",
  video: "Video",
  waiting_for_code_2: "SMS code ka wait time: ",
  camera_permission: "Camera ki permission settings se allow karen",
  invite_sent: "Invite bhej di",
  user_already_user_udhaar: "Yeh user pehle se Udhaar istamal kar raha hai",
  rs_20_earned: "Rs. 20 jeet liye",
  invite: "Invite Karen",
  remark: "tafseel",
  remark_is_required: "tafseel likhna zaruri hai",
  total_cash_in: "Total cash in",
  total_cash_out: "Total cash out",
  save_invoice: "Invoice mehfooz karain",
  add_item_list: "Item list add karain",
  enter_invoice_total: "Invoice ka total likhen",
  has_this_invoice_been_paid: "kia is invoice ki adaigi ho chuki hai?",
  add_customer_2: "Customer add karen",
  add_items_to_invoice: "Items invoice mai likhen",
  stock: "Stock",
  pcs: "Pcs",
  create_new_stock_item: "Naya stock item banaen",
  import_items: "Items import karen",
  selling_price_optional: "Sell Price (optional)",
  cost_price_optional: "Cost Price (optional)",
  current_stock_optional: "Mojoda stock (optional)",
  qty_for_low_stock_alert: "Low stock alert ke liye qty bataen",
  items_total: "Final Balance",
  confirm_invoice_amount: "Invoice ki rakam ki tasdeeq karain",
  your_invoice_amount_is: "Apki invoice ki rakam hai",
  invoice_successfully_saved: "Invoice mehfooz ho gae hai",
  send_invoice: "Invoice bhejein",
  create_new_invoice: "Naya invoice banaen",
  share_invoice: "Invoice share karain",
  do_not_share: "Share nahi karna",
  invoice_book_report: "Invoice Book Report",
  final_balance: "Final Balance",
  mobile_phone_number: "Mobile phone number",
  item_list_tafseel: "Item list / tafseel (optional)",
  send_free_sms_to: " ko free sms SMS send karen",
  only_you_and: "Sirf aap aur",
  can_see_these_entries: "yeh entries dekh sakte hain",
  add_first_transaction_of: " ka pehla hisaab likhein",
  cashbook_description:
    "Cash in / cash out se sales / Expenses maintain karen. Easy items ka stock. Free receipts.",
  invoicebook_description:
    "Sales aur expenses ka invoice banaen. Items ki details. 100% free.",
  udhaarbook: "Udhaar Book",
  cash_in_caps: "Cash In",
  cash_out_caps: "Cash Out",
  all_items: "Tamam Items",
  out_of_stock: "Stock Khatam",
  stock_of_goods: "Saman Ka Stock",
  manually_added: "Manually daala gaya",
  manually_reduced: "Manually kam kia",
  manage_stock_items: "Stock Items Manage Karen",
  add_new_item: "Naya Item Add Karen",
  select_unit: "Unit Select Karen",
  no_item_found: "Koi Item Nahi Mila",
  delete_item: "Item Delete Karen",
  all_data_of_this_item_will_be_deleted:
    "Iss item ka saara data delete kardia jayega",
  manage_stock: "Stock Manage Karen",
  collect_payment: "Payment Collect Karen",
  share_promotions: "Promotions Share Karen",
  win_daily_cash_prizes: "Roz Cash Prizes Jeeten",
  unlock_cash_prize: "Cash Prize unlock karain",
  switch_on_quiz_in_3_steps: "Quiz ON karnay ke 3 easy steps",
  start_using_udhaar_book: "Udhaar Book use karna shuru karen",
  pakistans_biggest_cash_reward_app: "Pakistan ka sab se bara cash reward app",
  play_quiz_and_win_cash_prizes_worth_10k:
    "Rs 10,000 ke daily inaam Quiz khelain, cash inaam jeeten",
  item_will_be_added_to_stock: "Item Stock Mein Add Ho Jayega",
  customer_added_successfully: "customer add ho gaya",
  customer_deleted_successfully: "customer delete ho gaya",
  invitation_successfull: "invitation bhej diya gaya",
  landmark: "Landmark",
  enter_landmark: "Landmark Enter Karen (Optional)",
  landmark_required_to_access_recharge:
    "Landmark Laazmi Hai Recharge Ko Access Karne Ke Liye",
  send_money: "Send money",
  collect_money: "Collect money",
  balance_settled: "Hisaab Clear",
  create_new_item: "Naya Item Banayein",
  view_item: "Item Dekhein",
  save_items_to_invoice: "Items Ko Invoice Mein Save Karen",
  infoAdded: "Information Add Ho Gayi",
  added: "add ho gaya",
  Request_Send: "Request Bhej Di Gayi",
  are_you_sure_you_want_to_delete_business:
    "Kia Aap Ye Karobaar Delete Karna Chahte Hain?",
  u_paisa: "Upaisa",
  going_back_will_discard_changes:
    "Peeche jaane se aapke changes zaya ho jaen ge",
  invoice_successfull: "Invoice Kamyab",
  amount_due: "Rakam Due",
  payment_due: "Payment Due",
  invoice_to: "Invoice banam",
  purchase_order_to: "Purchase order banam",
  amount_should_be_a_numbers: "Rakam Number Mein Rakhein",
  select_invoice_method: "Invoice Status select karen",
  info_updates: "information update ho gayi",
  info_added: "information add ho gayi",
  other_info_is_required: "Meharbani kar ky sari field ko bharen",
  info_deleted: "Information delete ho gayi",
  unpaid: "Paid Nahi",
  close: "band karen",
  user_exist: "User pehle se maujood hai",
  easyLoad: "EasyLoad",
  ucash: "uCash",
  ucash_balance: "uCash Balance",
  view_details: "Details dekhein",
  sell_easyload: "EasyLoad Bechein",
  earn_commission_upto_3: "2.5% tak commission kamaen",
  best_in: "Behtareen",
  ucash_descp:
    "Payment 3X Jaldi Collect Karen, 1% Tak CashBack Ke Saath Extra Cash Kamaen",
  get_early_access: "Jald Access Paen",
  thankyou: "Shukriya!",
  we_have_added_you_to_wait_list: "Aapko Wait List Pe Add Kardia Gaya Hai",
  there_are: "Abhi",
  people_ahead_of_you_to_earn_upto_1_cashback:
    "log aap se aage hain 1% cashback jeetne ke liye.",
  want_fast_access: "Jald Access Chahte Hain?",
  rp_50_recharge_ready: "Apka 50 Rupee Ka Recharge Ready Hai",
  avail_recharge_share_now:
    "Avail Karne Ke Liye Abhi Apne Friends Ke Sath Share Karen, Aur Caption Mein Yeh Hashtags Use Karen:",
  share_with_friends: "Doston Ke Saath Share Karen",
  add_cash: "Cash Add Karen",
  promotion: "Promotion",
  play_one_rupee: "1 Rupya Game Khelein",
  bill_payment: "Bill Payment",
  bill_payment_to_name: "Bill Payment to {name}",
  get_bill_discount: "Har bill par Rs.12.25 tak paayein",
  leaderboard: "Leaderboard",
  leaderboard_desc: "Mazeed Rechage Bechein Aur Bike Jeetein",
  sales_invoice: "Sales Invoice",
  expense_bill: "Expense Bill",
  business_Added_success: "Business Add Ho Gaya",
  maximun_limit_10000: "Payment limit Rs. 100 se Rs. 10,000 ke darmiyan hai",
  transaction_paid_successfully: "Transaction paid ho gayi",
  do_you_want_to_delete_image: "Kia aap image delete karna chahte hain",
  items_added_success: "items add ho gaye",
  no_item_found_add: "Koi item nahi mila.Add",
  stock_updated_success: "Stock update ho gaya",
  stock_deleted_success: "Stock delete ho gaya",
  stocks_deleted_success: "Stocks delete ho gaye",
  business_deleted_success: "Business delete ho gaya",
  update_amount_with_item_total: "Amount ko item total se update karen?",
  date_time: "Date / Time",
  description: "Tafseel",
  failed: "Fail Ho Gaya",
  deposit: "Jama Ki Rakam",
  ucash_report: "uCash Report",
  total_easyload_given: "Total EasyLoad Diya Gaya",
  unable_to_get_wallet_balance: "Wallet Ka Balance Lene Mein Naa Mumkin",
  ucash_list: "uCash Details",
  couldnt_request_early_access: "Early Access Ki Request Na Mumkin",
  easypaisa_account_number: "EasyPaisa Account Number",
  jazzcash_account_number: "JazzCash Account Number",
  enter_easypaisa_account_number: "EasyPaisa Account Number Enter Karen",
  enter_jazzcash_account_number: "JazzCash Account Number Enter Karen",
  your_account_number_is_easy_paisa_number:
    "Aapka Account Number Aapka EasyPaisa Phone Number Hota Hai",
  your_account_number_is_jazzcash_number:
    "Aapka Account Number Aapka JazzCash Phone Number Hota Hai",
  two_steps_away_from_percent: "Aap 2.5% kamane se sirf 2 steps door hain",
  enter_deposit_amount: "EasyLoad Ki Rakam Enter Karen",
  deposit_for_easyload: "EasyLoad Ki Amount",
  enter_the_amount_you_want_to_deposit:
    "Apne Account Mein Jo Rakam Jama Karna Chahte Hain, Usse Enter Karen",
  one_steps_away_from_percent: "Aap 2.5% kamane se sirf 1 step door hain",
  confirm_transfer: "EasyLoad Deposit Confirm Karen",
  easypaisa_will_send_you_a_pin: "EasyPaisa PIN send karey ga.",
  jazzcash_will_send_you_a_pin: "JazzCash PIN send karey ga.",
  enter_pin_easypaisa: "EasyPaisa App mein PIN enter karen.",
  enter_pin_jazzcash: "JazzCash App mein PIN enter karen.",
  from: "From",
  to: "To",
  your_easyload_account: "EasyLoad account",
  get_pin: "PIN Hasil Karen",
  easyload_deposit_MPIN_confirm: "Easyload deposit ke lye, MPIN confirm karen",
  request_mpin: "MPIN Request Karen",
  verify_mpin: "MPIN Verify Karen",
  did_not_recieve_mpin: "MPIN Recieve Nahi Hui?",
  try_again: "Phir Se Kosish Karen ",
  open_easypaisa_and_enter_pin:
    "Apna EasyPaisa App Kholein Aur PIN Enter Karen",
  open_jazzcash_and_enter_pin: "Apna JazzCash app kholein aur PIN Enter Karen",
  waiting_for_you_to_verify_easyload_easypaisa:
    "Hum wait kar rahe hain k aap EasyPaisa app par EasyLoad deposit amount verify karen",
  waiting_for_you_to_verify_easyload_jazzcash:
    "Hum Wait Kar Rahe Hain K Aap JazzCash App Par Easy Load Deposit Amount Verify Karen",
  deposit_failed_mpin_not_verified: "Deposit Fail Ho Gaya. MPIN Verify Nahi Hui",
  to_earn_35_on_easyload_verify_mpin:
    "2.5% Kamane Ke Liye, MPIN Ko Verify Karen",
  amount_deposited: "Amount Deposit Ho Gayi",
  ucash_deposit: "uCash Deposit",
  done: "Ho gaya",
  setup_for: "Setup for",
  finish_hbl_payment: "HBL payment setup karen 5 asaan steps mein",
  earn_commission_upto_2: "2.5% Commission Kamaen",
  login_into_hbl: "Login karen apne HBL App mein",
  tap_on_more_btn: "'MORE' button par tap karen",
  select_corporate_payment: "'Corporate Payment' select karen",
  select_udhaar_app_from_dropdown: "Dropdown se 'Udhaar App' select karen",
  add_details_and_done: "Details add karen aur bas ho gaya",
  waiting_for_mpin: "MPIN ka intezaar",
  add_ucash_balance: "uCash Balance Add Karen",
  takeout_cash: "Cash nikalein",
  add_your_bank_account: "Apna Bank Account Add Karen",
  to_change_bank_click_edit:
    "Account Add Ya Badalne Ke Liye Edit Ke Button Par Click Karen",
  account_number: "Account number",
  enter_account_number: "Account Number Enter Karen (Ph#)",
  number: "Number",
  insufficient_balance: "Balance Kam Hai",
  unable_to_withdraw: "Withdrawal Na Mumkin ",
  cash_take_out_successful: "Cash Take Out Kamyaab",
  cash_taken_out: "Cash Nikala Gaya",
  cash_will_be_deposited_in_24_hours:
    "Cash Aapke Account Mein 24 Ghanton Ke Andar Jama Kar Diya Jae Ga",
  easyload_details: "EasyLoad Details",
  search_customer_by_phone: "Customers Ko Number Se Dhoondein",
  contact_not_found: "Contact Nahi Mil Paya",
  setup_easyload_and_earn_up_to_35: "EasyLoad Setup karen aur kamaen 2.5%",
  finish_easyload_setup_2_steps: "EasyLoad Setup 3 Steps Mein Karen",
  earn_upto_35_commission: "2.5% Tak Commision Kamaen",
  step_one: "Step 1",
  step_two: "Step 2",
  step_three: "Step 3",
  tap_here: "Yahan tap karen",
  setup_screenlock: "Screen Lock Set Up Karen",
  enter_location: "Location Enter Karen",
  location_is_mandatory: "Location daalna laazmi hai",
  location_permission: "Setting se location ki permission allow karen",
  add_balance_with_easypaisa_hbl_ubl:
    "EasyPaisa, JazzCash Aur HBL Se Balance Add Karen",
  easyload_and_earn_upto_35: "EasyLoad Aur Kamaen2.5%",
  cash_back: "Cashback",
  recharge_report: "Recharge Report",
  udhaar_bonus: "Udhaar Bonus",
  load: "Recharge",
  package: "Package",
  packages: "Packages",
  select_a_package: "Package Muntakhib Karen",
  view_package_details: "Package Ki Details Dekhein",
  unable_to_get_networks: "Networks Nahi Dhoond Paye",
  easyload_amount: "EasyLoad Amount",
  enter_easyload_amount: "EasyLoad Amount Enter Karen",
  minimum_recharge_amount_limit_50:
    "Minimum Recharge Amount Limit 50 Rupee Hai",
  package_summary: "Package summary",
  commission_details: "Commission Details",
  udhaar_book_cashback: "Udhaar Book Cashback",
  confirm_package: "Package confirm karen",
  confirm_easyload: "Easyload confirm karen",
  sms_reciept_has_been_sent_to: "SMS Receipt Send Kardi Hai Is Number Pe",
  easyload_dispute_descp:
    "Kia Ghalat Number Par EasyLoad Ho Gaya Hai? Sahi Krwana Chahte Hain?",
  active_disputes: "Active Disputes",
  pending_disputes: "Closed Disputes",
  would_you_like_to_file_a_dispute:
    "Kia Ghalat Number Par Transaction Ho Gae? Sahi Krwana Chahte Hain?",
  select_entry_to_file_dispute:
    "Entry Ko Select Karen Aur Dispute Ko Report Krein",
  easyload_dispute_report: "EasyLoad Dispute Report",
  wallet_not_available: "Wallet dastiyaab nahi hai",
  wallet_is_currently_not_available:
    "Wallet filhal available nahi. Refresh button dabayein.",
  refresh: "Refresh karen",
  choose_category: "Category choose karen",
  catalog_builder: "Catalog Builder",
  catalog_descp:
    "Hamare maujooda products se apna catalog choose karke banayein",
  select_products: "Products select karen",
  cnic_placeholder: "Enter Karen 13 Digits CNIC Number ",
  cnic_number_length: "CNIC number 11 digits ka hona chahiye",
  sync: "Sync karen",
  Request_Send_success: "Apki payment request SMS ke zariye bhej di gayi hai",
  only_edit_from: "Ye transaction aap yahan se edit kar sakte hain",
  account_locked_description:
    "Account lock kar diya giya hai. Mazeed maloomat ke liye ham se Raabta karen.",
  not_editable: "Ap iss transaction ko edit nahi kar sakty",
  dispute_active: "Active",
  dispute_completed: "Mukammal",
  data_sync_karein: "Data Sync Karen",
  syncing: "Sync ho raha hai",
  items_updated_success: "Items successfully update ho gaye",

  // Salary Book
  paybook: "Staff Book",
  add_staff_and_maintain_your_daily_attendance:
    "Staff add karen aur daily haazri maintain karen. Staff ka advance. Free salary slip.",
  add_staff: "STAFF ADD KAREN",
  total_present: "Total Haazir",
  total_absent: "Total Ghair Haazir",
  staff_search_placeholder: "Staff (Naam Ya Number Se Search Karen)",
  add_staff_lowercase: "Staff Enter Karen",
  this_number_associate_with_another_staff:
    "Yeh number kisi aur staff ke saath associated hai",
  staff_name: "Staff Ka Naam",
  enter_staff_name: "Staff Naam Enter Karen",
  select_salary_type: "Salary Ki Kism Select Karen",
  monthly_description:
    "Mukarrarah Salary, Salary Payment Mahana, Mahine Ki Payment",
  weekly_description: "Hafta Waar Payment, 7 Days Work Cycle",
  daily_description: "Rozana Ki Payment, Payment Rozana Ke Kaam Ki Bunyad Par",
  hourly: "Ghante Ke Hisab Se",
  hourly_description: "Punch In - Punch Out time, Ghante ke hisab se payment system",
  salary_type_is_required: "Salary Type Laazmi Hai",
  enter_salary_amount: "Salary Ki Rakam Enter Karen",
  enter_staff_salary: "Staff Ki Salary Enter Karen",
  staff_salary: "Staff Ki Salary",
  salary_is_required: "Salary Zaroori Hai",
  regular_working_hours: "REGULAR WORKING HOURS",
  select_your_hours: "Hours Select Karen",
  working_hours_req: "Working hours darj karna zaroori hai",
  select_working_days: "Working Days Select Karen",
  working_days_staff_can_be_marked:
    "Working Days: Staff-' Haazir' Ya-' Ghair Haazir' Mark Ho Sakte Hain",
  non_working_days_staff_can_be_marked:
    "Non Working Days: Staff-' Haazir' Ya-' Paid Chutti' Mark Ho Sakte Hain",
  select_working_days_and_hours: "Working Hours Aur Days Select Karen",
  select_working_days_small: "Working Days Enter Karen",
  save_staff: "Staff Save Karen",
  joining_date: "Join Karne Ki Date",
  select_joining_date: "Joining Taareekh Select Karen",
  staff_joining_date: "Staff Ke Join Karne Ki Date",
  staff_success_add: "Staff successfully add ho gaya",
  all_staff: "Tamam Staff",
  present: "Haazir",
  set_date_filter: "Date Filter Set Karen",
  showing_staff_list_for: "Staff List Dikha Rahe Hain ",
  attendance: "Haazri",
  attendance_report: "Attendance Reports",
  staff_lowercase: "staff",
  presents: "Haazir",
  absents: "Ghair Haazir",
  days_lowercase: "Din",
  paid_holiday: "Paid Chutti",
  not_marked: "Mark nahi kiya gaya",
  advance_from_staff: "Staff Se Advance",
  pending_to_staff: "Staff Ko Deine Hain",
  closing_balance_small: " Closing Balance",
  balance_forward_from_last_month: "Pichle Mahine Ka Forward Balance",
  rs: "Rs.",
  payments_small: " Payments",
  net_payments_given_and_taken_from_staff:
    "Staff Se Li Gaye Aur Di Gaye Net Payments",
  salary: "Salary",
  total_salary_if_no_presents:
    'Total Salary. Agar Koi Haazri Mark Nahi Hui, Tou Salary " Zero" Rakhi Jae Gi',
  pay_staff: "Staff Ko Salary Dein",
  salary_slip: "Salary Slip",
  salary_must_be_in_numbers: "Salary Numbers Mein Rakhein",
  salary_cannot_be_0: "Salary 0 Nahi Ho Sakti",
  all_days: "Tamam din",
  mark_attendance_in_bulk: "Saarey din mark karen",
  add_salary: "Payment add karen",
  enter_salary_and_advance_payments_to_staff:
    "Staff ki salary aur advance payments enter karen",
  total_salary: "Total Salary",
  select_dates_for_salary_slip: "Salary Slip Ke Liye Dates Select Karen",
  staff_name_is_required: "Staff Ka Naam Laazmi Hai",
  working_hours_are_required: "Working Hours Laazmi Hain",
  working_hours_must_be_a_valid_number:
    "Workings Hours Ka Number Durust Hona Zaroori Hai",
  working_hours_cannot_be_a_0: "Workings Hours 0 Nahi Ho Sakte",
  profile_details: "Profile Details",
  staff_information: "Staff Ki Maloomat",
  staff_name_lowercase: "Staff Ka Naam",
  name: "Naam",
  job_title: "Job Title",
  salary_details: "Salary Ki Tafseelat",
  salary_type_lowercase: "Salary Ki Kism",
  working_hours: "Working Hours",
  working_days: "WORKING DAYS",
  other: "Doosra",
  auto_present: "Auto Haazri",
  delete_staff: "Staff Delete Karen",
  are_you_sure_you_want_to_delete_staff:
    "Kia Aap Staff Delete Karna Chahte Hain?",
  staff_deleetd_success: "Staff successfully delete ho gaya",
  staff_updated_successfully: "Staff Update Kamyaab Hua",
  no_data_for_date_range_was_found: "Date Range Ka Data Nahi Mila",
  are_you_sure_you_want_to_delete_this_payment:
    "Kia Aap Es Payment Ko Delete Karna Chahte Hain?",
  payment_deleted_successfully: "Payment successfully delete ho gayi",
  you_cant_schedule_a_payment_in_past:
    "Aap Past Mein Payment Ko Schedule Nahi Kr Skte",
  you_paid: "Aapne Diye",
  you_took: "Aapne Liye",
  payment_date: "Payment date",
  pay_online: "Online pay karen",
  confirm: "Confirm karen",
  youre_about_to_transfer_salary_of: "Aap salary transfer karne wale hain ",
  add_staff_account: "Staff ka account add karen",
  payment_success: "Payment successfully save ho gayi",
  edit_payment: "Payment edit karen",
  daily_statement: "Daily Statement",
  grand_total: "Grand Total",
  total_number_of_customers: "Customers ki tadad:",
  payment_details: "Payment Details",
  date_setted_success: "Date successfully set ho gayi",
  inventory_value: "Inventory value",
  inventory_cost: "Inventory Cost",
  stock_items: "Stock ke Items",
  inventory_item: "Inventory Items",
  sale_report: "Sale Report",
  item_sold: "Becha Hua Item",
  total_profit: "Total profit",

  //changes
  give_salary: "SALARY DEIN",
  give_advance: "ADVANCE DEIN",
  pay_cash: "Cash pay karen", //update
  pay_salary: "Salary pay karen",
  pay_advance: "Advance pay karen",
  inventory_report: "Inventory Report",
  verify_cashout: "Cashout verify karen",
  send_and_receive_payment: "Online payments bhejein aur receive karen",
  connect_wallet: "Wallet connect karen",
  setup_screen_lock: "Screen lock set karen",
  lock_is_mandatory: "Lock lagana zaroori hai",
  easypaisa: "EasyPaisa",
  jazzcash: "JazzCash",
  popular: "mashhoor",
  please_enter_registered_number:
    "Is account se registered mobile number darj karen",
  connect_you_wallet: "Apna wallet connect karen",
  enter_password: "Password darj karen",
  create_new_password: "Naya password banayein",
  re_confirm_password: "Password dobara confirm karen",
  reenter_password: "Password dobara darj karen",
  password_setted: "Password successfully bann gaya",
  one_steps_away_from_completion: "Aap completion se sirf 1 step door hain ",
  wallet_successful: "Wallet successfully connect ho gaya",
  whats_your_password: "Apka password kya hai?",
  enter_password_to_proceed: "OTP screen par jaane ke liye password darj karen",
  incorrect_password: "Ghalat password",
  please_enter_password: "password darj karen",
  fee: "Fee",
  password: "Password",
  please_enter_your_pass: "Apna password darj karen",
  please_confirm_your_pass: "Apna password confirm karen",
  password_mismatch: "Passwords match nahi ho rahe. Apna password dobara darj karen",
  verify_cashout_details: "Cashout ke details verify karen",

  staff_book: "Staff Book",
  working_hours_can_not_less_24: "Working hours 24 se zyada nahi ho sakte",
  date: "Date",
  unit: "Unit",
  cnic_number: "CNIC Number",
  suppliers_descp:
    "Supplier add karen aur purchasing maintain karen.Free payment reminder. Wasooli 3X tez.",
  add_supplier: "Supplier Add karen",
  this_number_associate_with_another_supplier:
    "Ye mobile number phele se registered hai",
  supplier_added_successfully: "Supplier successfully add ho gaya",
  supplier_deleted_successfully: "Supplier successfully delete ho gaya",
  create_suppliertitle: "Supplier add karen",
  total_supplier: "Suppliers",
  supplier_name: "Supplier ka naam",
  total_number_of_supplier: "Suppliers ki tadad:",
  supplierprofileheading: "Supplier Profile",
  do_you_want_to_delete_supplier: "Kya aap supplier delete karna chahte hain?",
  supplier_statement: "Supplier Statement",
  no_supplier_found: "Koi supplier nahi hai, Add karen",
  no_filter_match_supplier:
    "Koi supplier Apky filter se match nahi ho rhy hein.",

  customer_to_supplier: "Customer successfully Supplier mein convert ho gaya",
  supplier_to_customer: "Supplier successfully Customer mein convert ho gaya",
  convert_to_customer: "Customer mein convert karen",
  convert_to_supplier: "Supplier mein convert karen",
  convert_all_supplier_entries_to_customer:
    "Is Supplier ki tamam entries Customer section mein transfer ho jaayengi",
  convert_all_customer_entries_to_supplier:
    "Is Customer ki tamam entries Supplier section mein transfer ho jaayengi",
  stock_description:
    "Items add karen aur stock maintain karen. Ready made item catalog. Profit report.",
  supplier_updated_successfully: "Supplier successfully update ho gaya",
  quantity: "Quantity",
  customer_depposit_success:
    "Aapke customer k account mein paise deposit hogaye hain",
  cnic_required: "CNIC darj karna zaroori hai",
  easypaisa_transaction_details: "Easypaisa transaction details",
  enter_transfer_amount: "Transfer ka amount darj karen",
  easypaisa_in_out: "Easypaisa Paise Aana/Jaana",
  business_type: "Business Type",

  selling_price_label: "Selling price darj karen (optional)",
  cost_price_label: " Cost price darj karen (optional)",
  category: "Category",
  pay_bill: "Bill pay karen",
  pay_remaining: "Baqi ada karen",
  open_free_account: "Free account banayein",
  remaining_payment: "Baqi paise",
  you_have_received_cashback: "Aapko Rs. {amount} cashback mila hai!",
  create_account_claim_rewards_note: "Rewards claim karne aur bill payments par kamane ke liye Rupin account banayein.",
  activate_your_wallet: "Apna wallet activate karen",
  activate_wallet_note: "Payments bhejne, receive karne aur manage karne tak fori rasai hasil karen",
  activate_wallet: "Wallet activate karen",
  no_customer_founds: "Koi customer nahi mila",
  lets_setup_your_udhaar_account: "Chalein apka Udhaar account set up karte hain",
  pakistans_1_trusted_business_app: "Pakistan ka #1 Business Platform",
  you_will_receive_OTP_code: "Mujhe OTP code milega",
  notes_optional: "Notes / Tafseel (optional)",
  barcode_label: "Barcode (optional)",
  enter_category: "Category darj karen",
  Apna_insurance_plan_select_karein: "Apna insurance plan select karen",
  Insurance_summary: "Insurance summary",
  View_insurance_plans: "Insurance plans dekhein",
  Request_submitted: "Request submit ho gayi",
  Humne_aapki_insurance_request_record_karli_hai_Humara_numainda_jald_aapse_rabta_karayga:
    "Humne aapki insurance request record karli hai. Humara numainda jald aapse rabta karayga.",
  Aap_ka_plan_already_subscribed_hai: "Aap ka plan already subscribed hai",
  Already_subscribed: "Pehle se subscribed hai",
  order_management: "Order management",
  order_management_capital: "Order Management",
  stock_management: "Stock Management",
  stock_management_small: "Stock management",

  orders: "Orders",
  returns: "Returns",
  order_accepted: "Order accept ho gaya",
  order_pending: "Order pending hai",
  order_returned: "Order return ho gaya",
  order_id: "Order id #",
  order_status: "Order status",
  total_price: "Total price",
  reject: "Reject karen",
  accept_small: "Accept karen",
  product_id: "Product ID",
  order_qty: "Order ki qty",
  calculation: "Calculation",
  sub_total: "Sub total",
  total_tax: "Total tax",
  discount: "Discount",
  customer_details: "Customer details",
  email_address: "Email address",
  delivery_address: "Delivery address",
  are_you_sure: "Kya aap pakka,",
  you_want_to_reject_this_order: "ye order reject karna chahte hain?",
  order_reject: "Order reject",
  please_share_ur_reason: "Apni wajah batayein",
  add_note_to_the_order: "Order mein note add karen",
  order_confirmation: "Order confirmation",
  you_want_to_confirm_order: "kya aap ye order confirm karna chahte hain?",
  order_delivered: "Order deliver ho gaya",
  select_reason: "Wajah select karen",
  available_quantity: "Mojood quantity",
  edit_item_quantity: "Item ki quantity edit karen",
  per_item: "Per item",
  enter_reason_here: "Yahan wajah darj karen",
  order_payment_method: "Payment ka tareeqa",
  You_havent_placed_any_order_yet:
    "Abhi tak apka koi order nahi hai. Jaise hi order milega, ye yahan nazar aayega.",
  select_dispatch_date: "Dispatch date select karen",
  dispatch_date: "Dispatch ki date",
  date_of_purchase: "Kharidari ki tareekh",
  tracking_id: "Tracking id",
  return: "Return",
  total_return_value: "Total return value",
  evidance_of_return: "Return ka saboot",
  evidence: "Saboot",
  total_order_value: "Total order value",
  pending_on_customer: "Customer par pending",
  ready_to_ship: "Ship karne ke liye tayyar",
  returned: "Return hui",
  delivered: "Deliver ho gai",
  rejected: "Reject hui",
  shipped: "Ship hui",
  cancelled: "Cancel hui",
  cod: "COD",
  return_management: "Return Management",
  you_have_not_received_any_return:
    "Abhi tak aapko koi return order nahi mila, jab return hoga to uska status yahan dikhaya jayega.",
  received_customer_return: "Customer return mil gaya",
  awaiting_customer_return: "Customer return ka intezar",
  add_new_stock: "Naya stock add karen",
  upload_bulk_items: "Bulk items upload karen",
  upload_or_create_stock: "Bulk upload karen ya naya stock banayein",
  save_for_later: "Baad ke liye save karen",
  save_and_publich: "Save & publish karen",
  create_stock: "Stock banayein",
  sub_category: "Sub category",
  brand: "Brand",
  wholesale_price: "Wholesale price",
  msrp: "MSRP",
  minimum_order_qty_optional: "Minimum order qty",
  warranty_period_optional: "Warranty period (optional)",
  specification: "Specification",
  enter_specification: "Specification darj karen",
  delivery_date: "Delivery ki date",
  accepted: "Accept hui",
  sku: "SKU",
  in_stock: "Stock mein hai",
  price: "Price",
  publish: "Publish karen",
  add_item_details: "Item ki details add karen",
  pricing: "Pricing",
  inventory: "Inventory",
  addtional_information: "Mazeed maloomat",
  discount_optional: "Discount",
  page_not_found: "Page nahi mila",
  we_re_sorry_the_page_you_requested:
    "Maazrat, aap ne jo page manga tha woh nahi mil saka.",
  stock_image: "Stock ki tasveer",
  upload_image: "Image upload karen",
  date_of_creation: "Banane ki tareekh",
  customer_tracking_id: "Customer ka tracking id",
  order_details: "Order ki details",
  seller_tracking_id: "Seller ka tracking id",
  creation_date: "Banane ki tareekh",
  purchase_date: "Kharidne ki tareekh",
  evidence_image: "Sabooti tasveer",
  evidence_video: "Sabooti video",
  publish_all: "Sab publish karen",
  edit_stock: "Stock edit karen",
  qty_available: "Qty mojood",
  item_specification: "Item ki specification",
  warranty_period: "Warranty period",
  minimum_order_quantity: "Minimum order quantity",
  unpublished: "publish nahi hua",
  waiting_approval: "Manzoori ka intezar",
  delivery_add: "Address",
  managing_your_inventory_has_never:
    "Udhaar book ke sath inventory manage karna pehle kabhi itna asaan nahi tha",
  start: "Shuru karen",
  wasooli_tez_safe: "3x tez wasooli. 100% safe.",
  print_label: "Label print karen",
  publish_item: "Item publish karen",
  would_you_like_to_publish_this: "Kia aap is item ko publish karna chahte hain",
  would_you_like_to_publish: "Kia aap publish karna chahte hain",
  on_your_catalog: "apne catalog par ?",
  would_you_like_to_delete: "Kia aap delete karna chahte hain",
  this_item: "yeh item",
  all_selected_item: "tamam selected items",
  upload_photo: "Photo upload karen",
  msrp_optional: "MSRP (optional)",
  terms_and_conditions_optional: "Terms and conditions (apki marzi)",
  search_stock_by_name: "Naam se stock search karen",
  delivery_charges: "Delivery charges",
  partner_markup: "Partner markup",
  return_policy_and_warranty_details: "Return policy aur warranty ki details",
  order_filter: "Order filter",
  pdf_option: "Pdf option",
  search_by_order_number_customer_product:
    "Order #, customer ya product se search karen",
  mark_as: "Mark karen",
  you_want_to_ship_this_order: "kia aap is order ko ship karna chahte hain?",
  print_bill: "Bill print karen",
  print_loadsheet: "Loadsheet print karen",
  courier: "Courier",
  accounts: "Accounts",
  in_out: "In / Out",
  saddar_orders: "Saddar Orders",
  saddar_inventory: "Saddar Inventory",
  saddar: "Saddar",
  saddar_managenet: "Saddar Management",
  saddar_seller_central: "Saddar seller central",
  veiw_orders: "Orders dekhein",
  download_template: "Template download karen",
  in_the_file: "file mein ?",
  file_zip: "File.zip",
  uploading_with_dot: "Upload ho raha hai",
  download_invoice: "Invoice download karen",
  weight_gm: "Weight (gm)",
  select_weight_type: "Weight type select karen",
  please_select_order_weight: "Order ka weight select karen",
  select_parcel_type: "Parcel type select karen",
  please_select_parcel_type: "Parcel type select karen",
  ship_order: "Order ship karen",
  un_publish: "Un publish karen",
  add_variants: "Variants add karen",
  stock_variants: "Variants",
  placeholder_item_name: "masalan Powerbank",
  placeholder_item_category: "Category chunein",
  placeholder_item_subcat: "Sub category chunein",
  placeholder_item_brand: "Brand chunein",
  placeholder_item_price: "masalan Rs. 1000",
  placeholder_item_discount: "masalan Rs. 100",
  placeholder_item_quantity: "masalan 25",
  placeholder_item_moq: "masalan 5",
  placeholder_item_weight: "masalan 550 gm",
  placeholder_item_warranty: "Warranty period select karen",
  placeholder_item_detail: "masalan 20,000 mAh fast charging",
  placeholder_item_return_policy: "Warranty aur return ki details yahan likhein",
  discount_more_than_price: "Discount ki paise Price se zyada nahi ho sakti!",
  view_ledger: "Ledger dekhein",
  ledger: "Ledger",
  search_by_desc_amount_balance: "Description, amount ya balance se search karen",
  ledger_entries: "Ledger entries",
  actions: "Actions",
  time: "Time",
  ledger_management: "Ledger Management",
  ledger_non_ideal_desc:
    "Abhi ledger mein koi entry nahi hai, jab koi transaction hogi to yahan dikhayi degi.",
  search_by_desc: "Description se search karen",
  search_by_item_name: "Item ke naam se search karen",

  // Sale Book
  open_item: "Open item",
  stock_item: "Stock item",
  sale_pos: "Sale POS",
  draft_sale: "Draft sales",
  sale_items: "Sale items",
  item_non_ideal_desc: "List mein items add karen",
  enter_open_amount: "Open item ki amount darj karen",
  current_sale: "Maujooda sale",
  clear_item: "ITEMS CLEAR KAREN",
  pos_clear_all_items_title: "Tamam items clear karen?",
  pos_clear_all_items_body:
    "Kia aap waqai list se tamam items clear karna chahte hain?",
  new_sale: "Nayi sale",
  checkout: "Checkout",
  order_summary: "Order summary",
  item_name: "Item ka naam",
  qty: "Qty",
  amount: "Amount",
  tax: "Tax",
  payment_successfully: "Payment successful ho gai",
  amount_paid: "Ada shuda paise via",
  change: "Change",
  print_recipt: "RECEIPT PRINT KAREN",
  online_payment_checkout: "Apni sale ko online payment ke tor par record karen",
  udhaar_checkout: "Apni sale ko Udhaar ke tor par record karen",
  bill_amount: "Bill amount",
  online_payment: "Online payment",
  start_selling: "Items bechna shuru karen",
  create_stock_book_item: "Inventory mein items banayein ya open items bechna shuru karen",
  sell_open_item: "OPEN ITEMS BECHEIN",
  start_creating_item: "ITEMS BANANA SHURU KAREN",
  max_limit_reached: "Max limit puri ho gayi",
  draft_message: "Kia aap is order ko draft sales mein save karna chahte hain?",
  discard: "DISCARD KAREN",
  no_draft_sale: "Dikhane ke liye koi draft sale nahi",
  no_draft_sale_desc: "Apke pas abhi tak koi draft sale nahi hai.",
  on_going_sale: "Jari sale",
  on_going_sale_desc:
    "Kia aap dusri sale shuru karne se pehle is sale ko save karna chahte hain?",
  download_recipt: "Receipt download karen",
  print_receipt: "Receipt print karen",
  no_order_history: "Dikhane ke liye koi order history nahi",
  no_order_history_desc: "Apke pas abhi tak koi order history nahi hai.",
  order_history_detail_desc:
    "Sale ki details dekhne ke liye list se sale par click karen.",
  order_no: "Order no",
  pos_order_no: "Order no.",
  sale_details: "Sale details",
  reports: "Reports",
  low_stock_report: "Low stock report",
  low_stock_item_value: "Low stock items ki value",
  stock_in: "Stock in",
  stock_out: "Stock out",
  no_result_found: "Koi result nahi mila",
  to_adjust_your_filter:
    "Jo aap dhoond rahe hain usay talaash karne ke liye apna filter tabdeel karke dekhein.",
  stock_book: "Stock Book",
  stock_in_out: "Stock in / out",
  bulk_upload: "bulk upload",
  create_item: "Item Banayein",
  total_stock_items: "Total stock items",
  stock_value: "Stock value",
  low_stock_value: "Low stock value",
  add_quick_item: "Quick item add karen",
  create_stock_item: "Stock Item Banayein",
  change_image: "Tasveer change karen",
  secondary_unit: "Secondary unit",
  sell_rs: "Sell (Rs.)",
  costs_rs: "Cost (Rs.)",
  barcode_number: "Barcode number",
  expiry_date: "Expiry date",
  expiry_alert: "Expiry alert",
  batch_number: "Batch number",
  manufacturing_date: "Tayyari ki tareekh",
  sale_history: "Sales history",
  stock_report: "Stock report",
  total_items: "Total items",
  sales_history: "Sales history",
  sale_book: "Sale Book",
  print_invoice: "Invoice print karen",
  filter_sort: "Filter & Sort",
  view_invoice: "invoice dekhein",
  tax_added: "Tax add ho gaya",
  add_tax: "Tax add karen",
  disount_added: "Discount add ho gaya",
  add_dicount: "Discount add karen",
  subtotal: "Subtotal",
  enter_cash_amount: "Cash amount darj karen",
  charge_rs: "Charge RS",
  charge_amount_shortcut: "Charge RS. {amount} (Shift + Darj karen)",
  enter: "Darj karen",
  shift: "Shift",
  stock_list_desc: "Kya aap stock list mein bhi item update karna chahte hain?",
  online: "online",
  paid_via: "Ada kiya via",
  search_order: "Customer ka naam, amount, ya sale number se search karen",
  saleID: "sale ID",
  search_items: "Items search karen",
  no_result: "Koi result nahi mila",
  create: "Banayein",
  as_new_item: "naye item ke tor par",
  date_range: "Date range",
  additional_details: "Mazeed tafseelat",
  order_history_not_found: "Order history nahi mili",
  this_product_has_options_like_size_or_color:
    "Is product mein size ya color jaisi options hain",
  account_overview: "Accounts overview",
  stock_overview: "Stock overview",
  dat_set_karein: "Date set karen",
  as_customer: "customer ke tor par",
  as_supplier: "supplier ke tor par",
  supplier: "Supplier",
  save_changes: "Changes save karen",
  discard_changes: "Changes discard karen",
  upload_stock_items:
    "Apni file upload karen ya items ka format samajhne ke liye template download karen",
  upload_file: "File upload karen",
  select_file_or_drag: "File select karen ya yahan drag and drop karen",
  enter_phone_number: "Phone number darj karen",
  enter_supplier_name: "Supplier ka naam likhein",
  type_name: "Naam type karen",
  udhaar_payment_success: "Yeh transaction Accounts mein bhi add ho gaya",
  order: "Order",
  max_validation_message: "is se zyada nahi ho sakta",
  min_validation_message: "is se kam nahi ho sakta",
  file_size_validation: "File size is se zyada nahi honi chahiye",
  image_format_valid: "Barah-e-karam sahi image file select karen (JPEG, PNG, ya JPG)",
  cant_be: "nahi ho sakta",
  yearly: "Salana",
  weekly: "Haftawar",
  daily: "Rozana",
  monthly: "Mahana",
  overview: "Overview",
  purchases: "Kharidari",
  non_ideal_graph_udhaar_title: "Udhaar ka hisab nahi dikh raha?",
  non_ideal_graph_udhaar_subtitle:
    "Abhi record karen or muntakhib muddat ke liye udhaar ka hisab kitab dekhen",
  graph_udhaar_btn_title: "Udhaar record karen",
  non_ideal_acc_udhaar_title: "isne apka Udhaar dena hai?",
  non_ideal_acc_udhaar_subtitle:
    "Abhi customer add karen or unke saath udhaar ka hisab record karen",
  pending_accounts: "Baaki accounts",
  amount_in_rs: "Amount (Rs.)",
  low_stock_item: "Kam stock wale items",
  non_ideal_dash_stock_title: "Har item pe nazar rakhein",
  non_ideal_dash_stock_subtitle:
    "Item kam ho ya ziada, ab nazar rakhein har pal",
  non_ideal_graph_sale_title: "Apni sales ki taraqi dekhen",
  non_ideal_graph_sale_subtitle: "Barwaqt sales ki taraqi dekhte jayein",
  non_ideal_dash_sale_title: "Apne top items se ba-khabar rahen",
  non_ideal_dash_sale_subtitle: "Apka konsa item sab sy ziada demand mein hai?",
  add_top_item: "top item add karen",
  top_sale_item: "Top sale items",
  non_ideal_dash_purchase_title: "Apni tamam kharidari chutki mein dekho",
  non_ideal_dash_purchase_subtitle:
    "Kitne mei lei rahy, kitne mei bech rahy or kitna munafa kama rahy, sab dekho aik jaga pe",
  cost_rs: "Cost (Rs.)",
  sale_rs: "Sale (Rs.)",
  profilt_rs: "Profit (Rs.)",
  contact_no: "Contact no",
  due_date: "Due date",
  customer_created: "Customer kamyabi se create ho gaya",
  supplier_created: "Supplier kamyabi se create ho gaya",
  enter_total_amount_error: "Barah-e-karam Items ya Total Amount daalein",
  quantity_error: "Price ya Quantity 0 nahi ho sakti",
  not_available: "Dastiyaab nahi",
  item_discount_error: "Discount item ki price se zyada nahi ho sakta.",
  enter_tax: "Tax daalein",
  cash_small: "cash",
  write_name: "Naam likhein",
  enter_paid_amount: "Paid amount daalein",
  enter_recieved_amount: "Received amount daalein",
  summary: "Summary",
  balance_amount_error:
    "Received amount, total amount se zyada nahi ho sakta",
  expense_balance_amount_error:
    "Paid amount, expense amount se zyada nahi ho sakta",
  sale_balance_amount_error:
    "Paid amount, sale amount se zyada nahi ho sakta",
  sort: "Sort",
  delivery_challan: "Delivery challan",
  record_payment: "Payment record karen",
  send_payment: "Payment bhejein",
  print: "print",
  enter_received_amount: "Received amount daalein",
  discard_invoice_desc:
    "Kya aap wakai is invoice ko discard karna chahte hain? Yeh wapas nahi ho sakta.",
  discard_invoice_title: "Invoice discard karen",
  discard_bill_title: "Bill discard karen",
  discard_invoice_btn: "Ji haan, is invoice ko discard karen",
  discard_bill_btn: "Ji haan, is bill ko discard karen",
  discard_transaction_btn: "Ji haan, is transaction ko discard karen",
  discard_transaction_title: "Transaction discard karen",
  discard_contact_btn: "Ji haan, is contact ko discard karen",
  discard_contact_title: "Contact discard karen",
  max_length_6digit: "Zyada se zyada length: 6 digits",
  pos_sales: "POS (sales)",
  inout: "In / Out",
  already_exist_item:
    "Yeh item pehle se maujood hai. Duplicate items allow nahi hain",
  enter_quantity: "Quantity daalein",
  enter_price: "Price daalein",
  go_back_invoice_listing: "Invoice listing par wapas jayein",
  go_back_bill_listing: "Bill listing par wapas jayein",
  go_back_invoice_report: "Report par wapas jayein",
  non_ideal_invoice_book:
    "Doosre naam se item search karke dekhein jo aap dhoondh rahe hain.",
  non_ideal_bill_book:
    "Doosre naam se bill search karke dekhein jo aap dhoondh rahe hain.",
  create_invoice: "Invoice banayein",
  create_bill: "Bill banayein",
  preview: "Preview",
  create_purchase_bill: "Purchase bill banayein",
  edit_purchase_bill: "Purchase bill edit karen",
  edit_sale_invoice: "Sale invoice edit karen",
  edit_invoice: "Invoice edit karen",
  edit_bill: "Bill edit karen",
  max_20_character: "Zyada se zyada: 20 characters",
  type_signature_name: "Signature name type karen",
  invoice_date: "Invoice date",
  po_date: "PO date",
  invoice_items: "Invoice items",
  purchased_items: "Khareede gaye items",
  amount_received: "Wasool shuda amount",
  partial_paid: "Jazwi ada shuda",
  units: "Units",
  farokht: "Farokht",
  no_items_have_been_added_to_this_invoice_yet:
    "Abhi tak is invoice mein koi item add nahi hua",
  no_items_have_been_added_to_this_bill_yet:
    "Abhi tak is bill mein koi item add nahi hua",
  click_edit_invoice_to_include_the_items_you_billing_for:
    "Jo items aap bill kar rahe hain unhein shaamil karne ke liye 'Edit Invoice' par click karen.",
  click_edit_bill_to_include_the_items_you_billing_for:
    "Jo items aap bill kar rahe hain unhein shaamil karne ke liye 'Edit bill' par click karen.",
  no_products_were_added_to_this_invoice:
    "Is invoice mein koi products add nahi kiye gaye",
  you_can_only_add_items_to_an_invoice_while_its_unpaid:
    "Aap invoice mein items sirf tab add kar sakte hain jab woh unpaid ho.",
  report_download: "Report kamyabi se download ho gayi",
  backup_in_progress_shortly: "Backup jaari hai. Barah-e-karam thodi dair mein dobara koshish karen",
  error_downloading_report: "Report download karne mein masla hua",
  successfully_download_invoice: "Invoice kamyabi se download ho gayi",
  create_sale_invoice: "Sale invoice banayein",
  want_to_create_purchase_bill:
    "Purchase bill banana chahte hain? Yahan click karen",
  want_to_create_sale_invoice:
    "Sale invoice banana chahte hain? Yahan click karen",
  create_my_first_invoice: "Meri pehli invoice banayein",
  create_my_first_bill: "Mera pehla bill banayein",
  start_by_creating_invoice:
    "Invoice banakar shuru karen aur apne payments aur profits ek hi jagah track karen",
  are_you_sure_you_want_to_delete_item:
    "Kya aap wakai is item ko delete karna chahte hain?",
  contact_number: "Contact number",
  address_business: "Address",
  edit_customer: "Customer edit karen",
  update_record_sucessfully: "Record kamyabi se update ho gaya",
  amount_rs: "Amount Rs.",
  please_enter_item_name_first: "Barah-e-karam pehle item ka naam daalein!",
  only_one_unit_for_the_selected_item: "Muntakhib item ke liye sirf ek unit",
  reset_discount_message: "Item discount reset karen",
  close_without_saving: "Bina save kiye band karen?",
  invoice_no: "Invoice no",
  item_report: "Item report",
  available_stock: "Dastiyaab stock",
  low_stock_alert: "Kam stock alert",
  profile_tracker: "Munafa tracker",
  total_item_sold: "Kul beche gaye items",
  total_item_purchases: "Kul kharidari ki qeemat",
  total_sale_price: "Kul sale ki qeemat",
  stock_history: "Stock History",
  custom_date: "Custom date",
  stock_list: "Stock list",
  create_stock_item_details: "Stock item ki details banayein",
  edit_stock_item_details: "Stock item ki details edit karen",
  stock_book_reports: "Stock Book Reports",
  unsaved_changes: "Apke changes save nahi hue",
  unsaved_changes_go_back_message: "Apke changes save nahi hue. Kya aap waqai wapas jana chahte hain?",
  discard_stock: "Ji haan, is stock ko discard karen",
  go_back_item: "Item listing par wapas jayein",
  create_as_item: "Ise naya item banayein",
  add_more_item_detail: "Item ki mazeed details add karen",
  add_more_item_detail_desc:
    "Naya column add karne aur item ki mazeed details shaamil karne ke liye + icon par click karen.",
  please_select_primary_unit_first: "Barah-e-karam pehle primary unit select karen",
  secondary_unit_cannot_be_same_to_primary_unit:
    "Secondary unit, primary unit jaisi nahi ho sakti",
  primary_unit_cannot_be_same_to_secondary_unit:
    "Primary unit, secondary unit jaisi nahi ho sakti",
  You_can_add_your_custom_unit: "Aap apni custom unit add kar sakte hain",
  item_not_found: "Item nahi mila",
  sorry_could_not_find: "Maazrat, humein nahi mila",
  you_can_add_stock: "Neeche click karke ise apni stockbook mein add kar sakte hain!",
  stock_filter_non_ideal_screen:
    "Sab options dekhne ke liye apne filters tabdeel karen ya unhein clear karen.",
  no_report_found: "Koi report nahi mili",
  stock_report_non_ideal_decs:
    "Koi stock data dastiyaab nahi. Barah-e-karam apni inventory mein items add karen",
  add_items_now: "Abhi Items Add Karen",
  sale_report_non_ideal_decs:
    "Koi sales data nahi mila. Reports banane ke liye sales shuru karen",
  no_low_stock_found: "Koi kam stock nahi mila",
  low_stock_report_non_ideal_decs:
    "Koi kam stock item nahi mila. Apke sab products acha stock rakhte hain",
  add_unit: "Unit add karen",
  unit_modal_desc:
    "Agar ye item kisi aur unit mein bhi bika hai, to wo unit yahan select karen",
  unit_conversion_error: "Unit conversion zero nahi ho sakti",
  manufactor_lower_expiry_validation_msg:
    "Manufacturing date, expiry date se pehle honi chahiye",
  expiry_greater_manufactor_validation_msg:
    "Expiry date, manufacturing date se barabar ya zyada honi chahiye",
  expiry_alert_lower_expiry_validation_msg:
    "Expiry alert, expiry date se kam ya barabar honi chahiye",
  are_you_sure_you_want_to_leave_this_screen:
    "Kya aap wakai yeh screen chorna aur apne changes discard karna chahte hain?",
  item_deleted_successfully: "Item kamyabi se delete ho gaya",
  loss_profit: "Nuqsan/ Munafa",
  action: "Action",
  create_your_pin: "Apna PIN banayein",
  confirm_your_pin: "Apna PIN confirm karen",
  setup_pin_security: "Apni security ke liye PIN set up karen",
  create_pin: "PIN banayein",
  setup_pin: "PIN Setup karen",
  pin_code: "PIN code",
  activated: "Activate ho gaya",
  turn_off: "Band karen",
  change_pin: "PIN change karen",
  start_by_creating_purchase_invoice:
    "Purchase bill banakar shuru karen aur apne payments aur profits ek hi jagah track karen",
  sales_report: "Sales report",
  package_details: "Package details",
  package_done: "Package ho gaya hai ",
  package_successfully: "Package kamyabi se complete ho gaya",
  delete_single_item: "Kya aap wakai is item ko delete karna chahte hain?",
  delete_multiple_items: "Kya aap wakai in items ko delete karna chahte hain?",
  mobile_recharge: "Mobile Recharge",
  continue: "Jari rakhein",
  business_trust: "5.3M+ businesses ka trust",
  Verify_OTP: "OTP Verify karen",
  otp_code_sent: "Humne OTP bhej diya hai apke",
  enter_4_digit_otp_code: "Yahan 4 digit OTP code darj karen",
  wait_time: "Intezar ka waqt",
  money_khaata_is_updated: "Paise aa gaye — apka khaata update ho gaya",
  payment_received_successfully: "Payment kamyabi se receive ho gayi!",
  inventory_updated_with_received_items:
    "Inventory receive kiye gaye items ke sath update ho gayi",
  whatsapp_number: "Whatsapp number",
  your_data_is_being_restored: "Apka data restore ho raha hai",
  secured_data_transmission_in_progress:
    "Apke numbers taiyar ho rahe hain!",
  please_confirm_4_digit_pin: "Barah-e-karam apna 4 digit Udhaar book PIN confirm karen",
  forget_pin: "PIN bhool gaye?",
  back_to_login: "Login par wapas jayein",
  call_support: "Support ko call karen",
  verify_your_account: "Apna account verify karen",
  verify_your_account_decs:
    "Apna PIN reset karne ke liye Udhaar Book app ke zariye apni verification complete karen. Isse humein apke account ki security aur asliyat yaqeeni banane mein madad milti hai.",
  scan_to_open: "Open karne ke liye scan karen",
  search_udhaar_book_on_play_store: "Play store par Udhaar book search karen",
  or_download: "Ya download karen",
  just_need_few_detail_to_get_started:
    "Shuru karne ke liye bas chand details chahiye",
  kareen_store: "Kareen store",
  otp_verified_successfully: "Apka OTP kamyabi se verify ho gaya",
  verify_PIN: "PIN Verify karen",
  Please_verify_your_4_digits_Udhaar_book_PIN:
    "Barah-e-karam apna 4 digit RUPIN PIN verify karen",
  tries_left: "koshishein baqi",
  call: "Call",
  Select_the_options_below_to_receive_a_new_OTP:
    "Naya OTP hasil karne ke liye neeche diye gaye options mein se select karen",
  phone_sms: "Phone SMS",
  we_will_call_for_OTP_to_your: "Hum OTP ke liye call karen ge apke",
  hang_tight_ledgers: "Thoda intezar karen – apke ledgers taiyar hone wale hain!",
  sale: "Sale",
  keyboard_shortcuts: "Keyboard shortcuts",
  keyboard_shortcut_tooltip: "Keyboard shortcut",
  shortcut_switch_tabs: "Tabs ke darmiyan switch karen",
  shortcut_add_items_to_cart: "Items cart mein add karen",
  shortcut_start_new_sale: "Nayi sale shuru karen",
  shortcut_go_to_checkout: "Checkout par jayen",
  shortcut_search_items: "Items search karen",
  shortcut_scroll_up_items: "Items list upar scroll karen",
  shortcut_scroll_down_items: "Items list neeche scroll karen",
  shortcut_scroll_up: "Upar scroll karen",
  shortcut_scroll_down: "Neeche scroll karen",
  shortcut_add_customer: "Customer add karen",
  shortcut_charge: "Charge",
  available: "Dastiyaab",
  delete_bill: "Bill delete karen",
  delete_invoice: "Invoice delete karen",
  retry: "Dobara koshish karen",
  suppliers_descp_new:
    "Supplier add karen aur purchasing maintain karen.Free payment reminder. Wasooli 3X tez.",
  add_customer_descp_new:
    "Customer add karen aur khata maintain karen. Free payment reminder. Wasooli 3x tez.",
  i_will_receive: "Main loon ga",
  welcome_to_accounts: "Accounts mein khush aamdeed",
  add_customer_supplier_collection:
    "Apne customers aur suppliers add karen taake collection asaan rahe aur udhaar ka tension na ho",
  contact_type: "Contact ki qisam",
  status: "Status",
  download_files: "Files Download Karen",
  payment_pdf: "Payment PDF",
  payment_detail: "Payment Ki Tafseel",
  outstanding_orders: "Baqaya Orders",
  return_orders: "Return Orders",
  enter_weight: "Weight darj karen",
  weight_type: "Weight ki qisam",
  select_dimensions: "Dimensions muntakhib karen",
  dimension_type: "Dimension ki qisam",
  length: "Lambai",
  width: "Chorai",
  height: "Onchai",
  customers_statement: "Customers Ka Statement",
  suppliers_statement: "Suppliers Ka Statement",
  itook: "Maine Liye",
  igave: "Maine Diye",
  received: "Wasool Shuda",
  details: "Tafseel",
  invoice_terms_label: "Sharait",
  You_are_all_set: "Aap Bilkul Tayyar Hain!",
  txns_non_ideal_desc:
    "kamyabi se add ho gaya hai. Ab apne customer ke sath transactions track karna shuru karen.",
  transaction_for: "Transaction ke liye",
  note_placeholder: "Yahan tafseeli note likhein",
  add_image: "Image add karen",
  upload_new_file: "Nayi file upload karen",
  transaction_detail: "Transaction ki tafseel",
  expense_date_time: "Expense ki tareekh aur waqt",
  type: "Qisam",
  contact_list_non_ideal_title: "Phone Se Contacts Ki Ijazat Dein",
  contact_list_non_ideal_description:
    "Udhaar Book app ko ijazat dein taake tamam contacts ek sath add ho jayen",
  sync_contacts: "Contacts sync karen",
  hang_on: "Zara ruken!",
  your_contacts_are_being_synced: "Apke contacts sync ho rahe hain",
  edit_contact: "Contact edit karen",
  send: "Bhejein",
  message: "Message",
  message_description:
    "Asalam o Alaikum!Apka Book Ocean ke sath Rs. 855 baqaya hai.Foran apni paise ada kar dein.Shukriya!",
  reminder_type: "Reminder ki qisam",
  phone: "Phone",
  due_date_set: "Due date set ho gayi hai",
  due_date_remove: "Due date remove ho gayi hai",
  collection_date_set: "Collection date set ho gayi hai",
  collection_date_remove: "Collection date remove ho gayi hai",
  we_could_not_find_match: "Humein iske liye koi match nahi mila",
  supplier_with_this_number_already_exists:
    "Is number wala supplier pehle se maujood hai",
  customer_with_this_number_already_exists:
    "Is number wala customer pehle se maujood hai",
  you_can_either_view_supplier_details_or_move_to_customer_tab:
    "Aap supplier ki tafseel dekh sakte hain ya customer tab par ja sakte hain",
  you_can_either_view_customer_details_or_move_to_supplier_tab:
    "Aap customer ki tafseel dekh sakte hain ya supplier tab par ja sakte hain",
  move_to_customer: "Customer per jayen",
  move_to_supplier: "Supplier per jayen",
  view_supplier: "Supplier dekhein",
  view_customer: "Customer dekhein",
  i_will_give: "Main doon ga",
  i_will_recieve: "Main loon ga",
  no_more_notebooks_or_spreadsheets: "Ab Notebooks Ya Spreadsheets Ki Zaroorat Nahi",
  your_customers_forget_to_pay: "Apke Customers Paise Dena Bhool Jate Hain?",
  never_again: "Ab Aisa Nahi Hoga!",
  watch_tutorial: "Tutorial Dekhein",
  five_million_strong: "5.5 Million Log Humare Sath",
  and_growing_every_day: "- Aur Roz Barh Rahe Hain",
  no_more_notebooks_spreadsheets: "Ab Notebooks Ya Spreadsheets Ki Zaroorat Nahi",
  no_more_notebooks_spreadsheets_description:
    "Apne lene aur dene ka hisaab tarteeb se rakhein. Reminders bhejein, payments record karen, aur apne khaty ki update rakhein.",
  easy_payment_tracking: "Asaan Payment Tracking",
  easy_payment_tracking_description:
    "Aane aur jaane wali payments jaldi add karen, categories ke sath apna record tarteeb aur update rakhein.",
  real_time_account_balances: "Foran Account Balance",
  real_time_account_balances_description:
    "Jaldi dekhein customers per kitna baqaya hai aur suppliers ko kitna dena hai, sab kuch ek hi asaan screen per!",
  a_community_full_of_stories: "Kahaniyon se bhari ek community",
  testimonial_one:
    "Pehle mujhe yaad nahi rehta tha kis ne paisa dena hai, hisaab rakhna mushkil tha. Ab main apni tamam receivables ek jaga dekh sakta hoon aur reminders bhi bhej sakta hoon. Ispay collect karna bohat asaan ho gaya hai!",
  testimonial_two:
    "Pehle mujhe yaad nahi rehta tha kis ne paisa dena hai, hisaab rakhna mushkil tha. Ab main apni tamam receivables ek jaga dekh sakta hoon aur reminders bhi bhej sakta hoon. Ispay collect karna bohat asaan ho gaya hai!",
  testimonial_three:
    "Ab mujhe customers ke peechay bhaagna nahi parta. Main reminder set karta hoon aur baqi kaam app khud kar deta hai. Main ne to woh payments bhi wapis le lein jo main bhool chuka tha.",
  testimonial_four:
    "Payments track karna sar dard tha. Ab mujhe notify hota hai kis ne payment nahi ki, aur main sirf 'Send Reminder' dabata hoon. Bas itna hi asaan hai.",
  create_your_inventory: "Apni inventory banayen",
  low_stocks: "Kam Stock",
  forgot_to_update_them: "Aur Unhe Update Karna Bhool Gaye?",
  add_new_products_easily: "Naye Products Asaani Se Add Karen",
  add_new_products_easily_description:
    "Sirf chand clicks mein items banayen. Product ka naam, unit, price, aur stock ki tafseel jaldi darj karen—koi mushkil nahi.",
  low_stock_reports: "Kam Stock Ki Reports",
  low_stock_reports_description:
    "Ek nazar mein dekhein kya restock karna hai.Kam-stock reports banayen taake purchases plan karen aur sale miss na ho.",
  quick_stock_adjustment: "Fori Stock Adjustment",
  quick_stock_adjustment_description:
    "Kabhi bhi asaani se stock quantities update karen.Kharab, gum shuda ya return hue items ke liye chand clicks mein stock count theek karen.",
  testimonial_five:
    "Pehle payments aur stock haath se track karna mushkil tha. Ab sab kuch ek jaga hai—yeh app to lifesaver hai.",
  testimonial_six:
    "Pehle main stock kaghaz per likhta tha. Hamesha bhool jata tha kya becha hai. Ab sab kuch record ho jata hai aur main foran kam stock dekh sakta hoon.",
  testimonial_seven:
    "Mujhe quick item feature bohat pasand hai. Jab kuch naya bechta hoon to sab kuch bharne ki zaroorat nahi hoti—bas becho aur aage barho!",
  testimonial_eight:
    "Stock add karne mein pehle time lagta tha. Ab main sirf 'Stock In' dabata hoon aur sab kuch update ho jata hai. Ab andaza lagane ki zaroorat nahi.",
  add_sale: "sale add karen",
  mixing_up_your_sales: "Apni Sales Mix Kar Rahe Hain?",
  let_simplify_that: "Chaliye Ise Asaan Banate Hain",
  make_sales_second: "Second Mein Sale Karen",
  make_sales_second_description:
    "Walk-in sales tezi se handle karen—items select karen, payment type darj karen, aur foran receipt print ya share karen. Counter aur cash sales ke liye perfect.",
  send_invoices_get_paid_faster: "Invoices Bhejein Aur Jaldi Payment Payen",
  send_invoices_get_paid_faster_description:
    "Apne customers ke liye professional invoices banayen. Baqaya amounts track karen, taxes ya discounts lagayen, aur tafseeli invoices se credit sales asaani se manage karen.",
  track_every_rupee_coming: "Har Aane Wale Rupee Ko Track Karen",
  track_every_rupee_coming_description:
    "Customers se mili payments record karen. Sale invoices ke against partial ya full payments asaani se track karen aur har customer ki saaf payment history rakhein.",
  testimonial_nine:
    "Customers ke sath invoices banana aur share karna bas chand second ka kaam hai. Ab mujhe haath se kuch likhna nahi parta — app foran aur saaf tareeqe se sab kuch kar deta hai.",
  testimonial_ten:
    "Is app se daily sale entries bilkul asaan ho gayi hain. Yeh mere kaam mein perfectly fit hoti hai — main chalte phirte har sale add kar sakta hoon, kuch bhi miss nahi hota.",
  testimonial_eleven:
    "Yeh app meri tamam sales ka bilkul saaf summary deta hai. Main seconds mein daily, weekly, ya monthly progress dekh sakta hoon, jo behtar decisions lene mein bohat madad karta hai.",
  testimonial_twelve:
    "Har sale per kitna cash mila, yeh track karna asaan hai. App tamam aane wali payments ko tarteeb se rakhta hai aur mere records per mera aitmaad barhata hai.",
  no_transactions_to_show_yet: "Abhi tak koi transaction nahi hai",
  no_transactions_to_show_yet_subtitle:
    "Jab aap payments record karna shuru karenge, to apki tamam activity yahan nazar ayegi",
  go_to_accounts: "accounts per jayen",
  no_customer_records_yet: "Abhi tak koi customer record nahi hai",
  no_customer_records_yet_subtitle:
    "Accounts section mein apne customers add karen taake unka baqaya track karen aur reminders asaani se manage karen.",
  no_supplier_records_yet: "Abhi tak koi supplier record nahi hai",
  no_supplier_records_yet_subtitle:
    "Accounts section mein apne suppliers add karen taake apka baqaya track karen aur koi payment miss na ho.",
  add_purchase: "purchase add karen",
  expenses_piling_up: "Expenses Barhte Ja Rahe Hain?",
  organize_and_optimize: "Tarteeb Dein Aur Behtar Banayen.",
  record_all_your_purchases_one_place: "Apni Tamam Purchases Ek Jaga Record Karen",
  record_all_your_purchases_one_place_description:
    "Bills, supplier payments, aur expenses asaani se track karen. Ab andaza lagane ki zaroorat nahi—har jaane wali transaction seconds mein log karen.",
  smart_stock_easy_purchasing: "Smart Stock, Asaan Purchasing",
  smart_stock_easy_purchasing_description:
    "Suppliers se purchases record karen aur stock khud ba khud update ho jaye. Item-wise purchases log karen, dues track karen, aur apni inventory ko ek hi baar mein accurate rakhein.",
  stay_top_of_business_spending: "Apne Business Ke Kharche Per Nazar Rakhein",
  stay_top_of_business_spending_description:
    "Stock se hat kar business ke kharchon ko track karen. Chahe rent ho, salaries ho, ya utility bills—har jaane wali payment record karen taake apka cash flow control mein rahe.",
  testimonial_thirteen:
    "Main yeh app apni tamam purchases aur payments record karne ke liye use karta hoon. Stock kharidne se le kar rent tak sab kuch ab likha hua hai — is se meri expenses manage karna pehle se kahin behtar ho gaya hai.",
  testimonial_fourteen:
    "Mujhe sab se zyada yeh feature pasand hai ke yeh tamam purchases ki reports banata hai. Jab bhi zaroorat ho main mukammal spending history dekh sakta hoon, jis se sab kuch bohat transparent ho jata hai.",
  testimonial_fifteen:
    "App se seedha purchase orders banane aur bhejne ki suhoolat ne mera business bohat professional bana diya hai. Ab mujhe haath se likhna ya bikhri hui messages bhejni nahi partin.",
  testimonial_sixteen:
    "App mujhe poori flexibility deta hai ke main kaise payment ki hai mark karoon — poori, adhoori, ya credit per. Is se mere records accurate rehte hain aur mujhe apne cash flow ki sahi tasveer milti hai.",
  view_reports: "Reports dekhein",
  over_due_accounts: "Overdue accounts",
  customer_supplier: "Customer / Supplier",
  cta: "CTA",
  item_list: "items ki list",
  value_Rs_dot: "Value-Rs.",
  stock_value_report: "Stock value report",
  top_selling_items: "Sab se zyada bikne wale items",
  dashboard: "Dashboard",
  customers: "Customers",
  suppliers: "Suppliers",
  purchase: "Purchase",
  request_reports: "Reports request karen",
  report_name: "Report ka naam",
  enter_report_name: "Report ka naam darj karen",
  report_details: "Report ki tafseel",
  enter_report_details: "Report ki tafseel darj karen",
  quantity_sold: "Bechi gayi quantity",
  length_width_height: "Lambai x chorai x onchai inches",
  items_type: "Items ki qisam",
  unit_type: "Unit ki qisam",
  barcode: "Barcode",
  jpg_png_file_size_no_more_than: "JPG ya PNG, file size 3MB se zyada na ho",
  value: "Value",
  date_filter: "Tareekh Filter",
  current_quantity: "Mojoda quantity",
  stock_in_quantity: "Stock in ki quantity",
  stock_out_quantity: "Stock out ki quantity",
  barcode_error: "Barcode mein masla",
  updated_stock_inventory: "Stock inventory update ho gayi",
  record: "Record karen",
  pos: "POS",
  pos_sale: "POS Sale",
  create_pos: "POS create karen",
  pos_report: "POS report",
  number_of_transctions: "Transactions ki tadaad",
  expence: "Expense",
  purchase_bill_report: "purchase bill report",
  expence_report: "expense report",
  search_customers_by_name_or_posId_placeholder: "Naam ya POS# se search karen",
  invoice_report: "Invoice report",
  too_many_walk_ins: "Bohat Zyada Walk-Ins?",
  keep_them_smooth_with_pos: "POS Ke Sath Unhe Asaan Rakhein",
  create_pos_sale: "POS sale create karen",
  stock_item_in_pos: "POS Mein Stock Item",
  stock_item_in_pos_description:
    "Sale karte waqt seedha apne stock se items add karen. Is tarah, har bill ke sath apki inventory khud update ho jati hai — is liye apko hamesha pata hota hai ke kya bik raha hai aur kya kam ho raha hai.",
  open_item_description:
    "Open Items woh sales hain jo bani hain magar abhi mukammal payment nahi hui. Pending payments asaani se track karen, reminders bhejein, aur jab customer payment karay to update karen — is se apko hamesha pata rahega ke konsi sales open hain aur kitna baqaya hai.",
  draft_sales: "Draft Sales",
  draft_sales_description:
    "Draft Sales se apko un orders ko save karne ki suhoolat milti hai jo abhi final nahi hue, chahe customer soch raha ho ya apko sale baad mein mukammal karni ho. Jab customer tayyar ho to wapis aa kar edit ya confirm karen.",
  forgot_invoices: "Invoices Bhool Jate Hain?",
  we_help_you_stay_on_track: "Hum Apko Track Per Rakhne Mein Madad Karen Ge.",
  sale_invoice_desc:
    "Sales Invoice mein items, quantities, prices, taxes, aur total amount jaisi tamam tafseel hoti hai — is se apko aur apke customer dono ko transaction ka saaf record milta hai",
  share_instantly: "Foran Share Karen",
  share_instantly_desc:
    "Invoices seedha apne customers ko WhatsApp, email, ya print ke zariye bhejein. Na haath se likhna, na deri — apke customer ko bill foran mil jata hai",
  track_payments: "Payments Track Karen",
  track_payments_desc:
    "Asaani se dekhein konsi invoices mukammal paid hain, konsi adhoori, ya abhi pending hain. Is se apko collections per nazar rakhne aur baqaya amounts follow up karne mein madad milti hai, kuch bhi miss nahi hota.",
  frustrated_with_unpacked_purchases: "Bikhri Hui Purchases Se Pareshan Hain?",
  let_bring_order: "Chaliye Tarteeb Layen",
  keep_records_organized: "Records Ko Tarteeb Se Rakhein",
  keep_records_organized_desc:
    "Tamam purchase orders ek hi jaga stored hote hain, is liye aap jaldi purani orders check kar sakte hain, supplier prices compare kar sakte hain, aur mukammal purchase history rakh sakte hain",
  send_suppliers_easily: "Suppliers Ko Asaani Se Bhejein",
  send_suppliers_easily_desc:
    "Apne suppliers ke sath purchase orders bas chand clicks mein banayen aur share karen — WhatsApp, email, ya print ke zariye. Is se sab kuch saaf aur professional rehta hai.",
  track_pending_orders: "Pending Orders Track Karen",
  track_pending_orders_desc:
    "Dekhein konsi orders abhi open hain, konsi deliver ho chuki hain, aur kya baqaya hai. Is se apko apna stock aur cash flow behtar tareeqe se manage karne mein madad milti hai.",
  please_select_start_end_date: "Meherbani karke start aur end date select karen",
  purchase_expense: "Purchase & Expense",
  send_invoices: "Invoices Bhejein",
  sale_pos_desc:
    "POS ke sath, aap jaldi receipt bana sakte hain, payment record kar sakte hain, aur foran customer ko de sakte hain. Yeh tez, asaan, aur walk-in customers ke liye perfect hai.",
  sale_invoices: "Sale Invoices",
  purchase_bill_desc:
    "Suppliers ko phone calls ya messages per pareshan karna band karen. Purchase Bill ke sath, aap saaf aur professional requests bhej sakte hain — items, prices, aur quantities sab ek hi jaga.",
  expenses: "Expenses",
  expenses_description:
    "Expenses apko business chalane per kharch hua paisa record karne mein madad karte hain — jaise rent, utilities, salaries, ya supplies. Is se apke tamam business expenses achi tarah documented rehte hain.",
  create_purchase: "Purchase create karen",
  lost_in_your_expenses: "Apne Expenses Mein Uljhan Mein Hain?",
  stay_organized: "Tarteeb Mein Rahein",
  create_expense: "Expense create karen",
  avoid_missed_entries: "Chooti Hui Entries Se Bachein",
  avoid_missed_entries_desc:
    "Expenses hote hi record karen taake kuch bhool na ho aur apke accounts accurate rahen.",
  track_all_business_costs: "Tamam Business Costs Track Karen",
  track_all_business_costs_desc:
    "Har chota bara expense asaani se darj aur save karen, taake apko hamesha pata rahe ke apka paisa kahan ja raha hai.",
  summary_of_your_cash_out: "Apke Cash Out Ka Summary",
  summary_of_your_cash_out_desc:
    "Ek nazar mein dekhein apke business se kitna paisa gaya hai. Sahi expense summary ke sath, apko hamesha pata rahega apka cash kahan ja raha hai aur aap behtar planning kar sakte hain.",
  record_expense: "Expense record karen",
  expense_amount: "Expense ki paise",
  select_category: "Category select karen",
  paid_amount: "Paid paise",
  company: "Company",
  company_supplier: "Company / Supplier",
  total_paid_expenses: "Kul paid expenses",
  total_unpaid_expenses: "Kul unpaid expenses",
  expense_id: "Expense ID",
  options: "Options",
  expense_report: "Expense report",
  delete_expense: "Expense delete karen",
  are_you_sure_you_want_to_delete_this_expense:
    "Kya aap is expense record ko delete karna chahte hain?",
  expense_has_been_successfully_recorded:
    "Expense successfully record ho gaya hai",
  expense_has_been_successfully_updated:
    "Expense successfully update ho gaya hai",
  companies: "Companies",
  search_by_expense_id: "Expense # se search karen",
  additional_details_subtitle: "(Notes, image upload aur date)",
  additional_details_subtitle_stock:
    "(Barcode, Expiry, Batch number, Wholesale price, Manufacturing date)",
  discard_expense_btn: "Ji haan, is expense ko discard karen",
  this_action_cannot_be_undone: "Yeh action wapas nahi ho sakta.",
  Are_you_sure_you_want_to_change_the_customer_to_supplier:
    "Kya aap customer ko supplier mein tabdeel karna chahte hain?",
  Are_you_sure_you_want_to_change_the_supplier_to_customer:
    "Kya aap supplier ko customer mein tabdeel karna chahte hain?",
  are_you_sure_delete_suppier: "Kya aap is supplier ko delete karna chahte hain?",
  are_you_sure_delete_customer:
    "Kya aap is customer ko delete karna chahte hain?",
  save_to_draft_sales: "Draft sales mein save karen",
  delete_draft: "Draft delete karen",
  delete_draft_desc: "Kya aap is draft sale ko delete karna chahte hain?",
  search_by_order: "Order search karen",
  no_filter_match:
    "In filters se koi result nahi mila. Filters adjust ya clear kar ke dekhein",
  item_name_placeholder: "Maslan Cheeni",
  select_to_type_or_add: "Type karne ya add karne ke liye select karen",
  primary_unit: "Bunyadi unit",
  enter_number_to_send_reminder: "Reminders bhejne ke liye number darj karen",
  quantity_placeholder: "50",
  unit_placeholder: "Maslan Kg, Piece, Box",
  secondary_unit_placeholder: "Maslan Dozen, Carton",
  sell_rs_placeholder: "e.g. 120",
  cost_rs_placeholder: "e.g. 100",
  low_stock_alert_placeholder: "e.g. 10",
  enter_batch_number: "Batch number darj karen",
  clear_filters: "Filters clear karen",
  stock_in_updated: "Stock in update ho gaya",
  stock_out_updated: "Stock out update ho gaya",
  enter_or_create: "Darj karen ya banayein",
  edit_expenses: "Expenses edit karen",
  id: "ID",
  try_another_filter_to_find_what_youre_looking_for:
    "Jo dhoondh rahe hain usy paane ke liye koi aur filter try karen.",
  select_company_or_supplier: "Company ya supplier select karen",
  avb_stock: "Mojood stock",
  delete_pos: "POS delete karen",
  are_you_sure_you_want_to_delete_this_pos:
    "Kya aap is POS ko delete karna chahte hain",
  create_stock_book: "Stock book banayein",
  low_stock_report_non_ideal_decs_half: "Koi low stock item nahi mila.",
  back_to_report: "Report par wapas jayein",
  no_sales_data_found: "Sales ka koi data nahi mila",
  create_a_sale_to_generate_report: "Report banane ke liye sale create karen.",
  create_sale: "Sale banayein",
  start_making_sales_to_generate_reports:
    "Reports banane ke liye sales karna shuru karen",
  expense_search_description:
    "Jo dhoondh rahe hain usy paane ke liye koi aur naam ya number se search karen",
  create_search_term_as_new_customer: "'{name}' ko naye customer ke tor par banayein",
  create_search_term_as_new_supplier: "'{name}' ko naye supplier ke tor par banayein",
  go_back_to_expense_listing: "Expense listing par WAPAS JAYEIN",
  go_back_to_quick_sale_listing: "Quick sale listing par WAPAS JAYEIN",
  remind_with_whatsapp_add_contact:
    "WhatsApp par reminder ke liye contact number add karen.",
  add_customer_to_sale: "Receipts jaldi share karne ke liye customer link karen",
  create_your_own_item: "Apna khud ka item banayein",
  catalog_items: "Catalogue items",
  preview_image: "Image preview karen",
  go_back_to_POS: "POS listing par wapas jayein",
  non_ideal_pos_book:
    "Jo dhoondh rahe hain usy paane ke liye POS ko kisi aur naam se search karen.",
  backup_data: "Data ka backup lein",
  available_balance: "Mojood balance",
  add_money: "Add Money",
  request: "Request",
  easyload_packages: "Easyload & packages",
  bill_payments: "Bill payments",
  vouchers: "Vouchers",
  shop: "Shop",
  sms_bundles: "SMS bundles",
  see_more_bills: "Aur bills dekhein",
  sell_vouchers: "Vouchers bechein",
  search_transactions: "Transactions search karen",
  transaction_id: "Transaction ID",
  scan_and_add_money_to_your_wallet: "Scan karen aur apne RUPIN account mein paisa add karen",
  account_title: "Account ka title",
  IBAN: "IBAN",
  copy: "Copy karen",
  easy_QR_code_payments: "Asaan QR code payments",
  share_details: "Details share karen",
  download_qr_code: "QR code download karen",
  print_qr_code: "QR code print karen",
  trusted_by_million_users: "5.3+ million users ka bharosa",
  licensed_by_State_Bank_of_Pakistan: "State Bank of Pakistan se licensed",
  auto_reconciliation: "Auto reconciliation",
  send_anywhere: "Kahin bhi bhejein",
  receive_anywhere: "Kahin bhi receive karen",
  free_and_instant: "Free & Fori",
  your_account_just_got_an_upgrade: "Apka account abhi upgrade hua hai.",
  it_only_takes_a_minute: "Sirf ek minute lagta hai",
  unlock_benefits_by_upgrading_your_account:
    "Account upgrade kar ke benefits unlock karen",
  upgrade_account: "Account upgrade karen",
  scan_qr_or_share_download_link: "QR scan karen ya download link share karen",
  copy_link: "Link copy karen",
  share_link: "Link share karen",
  upgrade_account_download_desc:
    "Account upgrade karne ke liye, RUPIN App download karen, QR code scan karen, ya download link copy kar ke share karen.",
  wallet_onboarding_b_slide1_title: "Har payment ke liye ek money",
  wallet_onboarding_b_slide1_subtitle: "Asaani se track aur manage karen",
  wallet_onboarding_b_slide2_title: "Pay karen kahin bhi, kabhi bhi",
  wallet_onboarding_b_slide2_subtitle: "Fast, free aur limitless transfer",
  wallet_onboarding_b_slide3_title: "Fori paise hasil karen. 100% free",
  wallet_onboarding_b_slide3_subtitle: "Na koi fees, na koi limit",
  pending_collections_payments: "Baqaya collections & payments",
  search_contact: "Contact search karen",
  contact: "Contact",
  document_no: "Document no",
  total_money_in: "Total paisa aaya",
  total_money_out: "Total paisa gaya",
  money_in: "Paisa aaya",
  money_out: "Paisa gaya",
  new_entry_in: "Nayi entry (In)",
  new_entry_out: "Nayi entry (Out)",
  view_all: "Sab dekhein",
  choose_mobile_network: "Network select karen",
  recharge_type: "Recharge ki qisam",
  network_service_currently_unavailable: "Yeh service abhi {network} ke liye dastiyaab nahi hai",
  bank_name: "Bank ka naam",
  account_details: "Account ki details",
  enter_account_number_IBAN: "Account number / IBAN darj karen",
  enter_amount_rs: "Amount Rs. darj karen",
  enter_amount_here: "Yahan amount darj karen",
  raast_id: "Raast ID",
  linked: "Link hai",
  unlinked: "Link nahi hai",
  link: "Link karen",
  linking: "Link ho raha hai...",
  unlink: "Link khatam karen",
  raast_id_unlink: "Raast ID ka link khatam karen",
  raast_id_unlink_desc: "Kya aap yaqeen se apni Raast ID ka link khatam karna chahte hain? Aap ise kisi bhi waqt dobara link kar sakte hain.",
  insufficient_balance_please_try_different_amount:
    "Balance kam hai, koi aur amount try karen",
  go_to_wallet: "Home par jayein",
  share_receipt: "Receipt share karen",
  review: "Review karen",
  mobile_network_new: "Mobile network",
  select_customer: "Customer select karen",
  send_request: "Request bhejein",
  pending_amount: "Baqaya amount",
  phone_number_already_exist:
    "Phone number pehle se maujood hai, koi doosra number try karen",
  tired_of_payment_chaos: "Payment ki uljhan se thak gaye?",
  simplify_with_one_smart_wallet: "Ek smart wallet se sab asaan banayein.",
  let_get_started: "Chaliye shuru karte hain",
  earn_money_on_every_transaction: "Har transaction par paisa kamayein",
  turn_every_recharge_the_more_you_earn:
    "Har recharge, bill payment aur voucher sale ko extra income mein badlein jitna zyada bechein ge, utna zyada kamayein ge.",
  track_every_transaction_effortlessly: "Har transaction ko asaani se track karen",
  view_all_your_payments_stay_on_top_of_every_transaction:
    "Apni tamam payments, Add Money aur send money ek hi jagah dekhein. Apne business records ko organized rakhein aur har transaction par nazar rakhein.",
  send_money_anytime_anywhere: "Paisa bhejein, kabhi bhi, kahin bhi",
  make_instant_payments_straight_without_delays_or_extra_steps:
    "Apne wallet se seedha kisi bhi bank ya wallet user ko instant payment karen. Fast, secure aur reliable, koi delay ya extra steps nahi.",
  first_activate_your_wallet_in_3_easy_steps:
    "Pehle apna wallet 3 asaan steps mein activate karen",
  open_camera: "Camera open karen",
  and_scan_barcode: "aur barcode scan karen",
  from_your_phone: "apne phone se",
  udhaar_book_app_from: "Udhaar book app ",
  play_store: "play store",
  tap_on_wallet_icon: "Wallet icon par tap karen",
  and_verify_KYC: "aur KYC verify karen",
  download_app: "App download karen",
  application_completed: "Application complete ho gayi",
  application_ID: "Application ID",
  account_activation: "Account activation",
  your_account_will_be_activated_in: "Aapka account itni dair mein activate ho jayega",
  minutes: "minute",
  select_package: "Package select karen",
  choose_package: "Package choose karen",
  hybrid: "Hybrid",
  data: "Data",
  social: "Social",
  mini: "Mini",
  search_package: "Package search karen",
  select: "Select karen",
  validity: "Validity",
  electricity: "Bijli",
  gas: "Gas",
  govt_fees: "Sarkari fees",
  internet: "Internet",
  water: "Pani",
  choose_bill_category: "Bill category choose karen",
  bill_organization_company: "Bill organization/company",
  eg_wapda: "Maslan WAPDA",
  type_scan_account_number: "Account number type karen ya scan karen",
  enter_customer: "Customer darj karen",
  billing_organization: "Billing organization",
  consumer_num: "Consumer #",
  billing_month: "Billing ka mahina",
  bill_amount_after_due_date: "Due date ke baad bill amount",
  select_voucher: "Voucher select karen",
  voucher: "Voucher",
  voucher_to: "Voucher to {name}",
  easyload_to_name: "{item} to {name}",
  bills: "Bills",
  mobile_packages: "Mobile packages",
  total_easyload: "Total easyload",
  total_commission: "Total commission",
  total_bills_paid: "Total ada shuda bills",
  total_vouchers_bought: "Total khareede gaye vouchers",
  all_transactions: "Tamam transactions",
  nonIdealPendingCollectionSubtitle:
    "Dosto aur contacts se yahin asaani se paisa collect karen. Request bhejne ke baad, yeh is list mein nazar aayegi.",
  account_not_found_please_enter_valid_account_number_or_IBAN:
    "Account nahi mila, sahi account number ya IBAN darj karen",
  copied: "Copy ho gaya",
  package_not_found: "Package nahi mila",
  no_data_found: "Koi data nahi mila!",
  view_transactions: "Transactions dekhein",
  amount_range: "Amount range",
  easyload: "Easyload",
  no_transactions_found: "Koi transaction nahi mila",
  balance_insufficient: "Balance kam hai",
  your_sales_your_expenses_your_profit_crystal_clear:
    "Aapki sales, aapke expenses, aapka profit. Bilkul saaf.",
  send_invoices_collect_payments_easy_free:
    "Invoices bhejein. Payments collect karen. Asaan & Free",
  know_who_owes_remind_automatically_get_paid_3x_faster:
    "Jaanein kis par udhaar hai. Khud reminder bhejein. 3x tez payment payein.",
  keep_stock_updated_never_miss_a_sale_sell_smarter:
    "Stock update rakhein. Koi sale miss na karen. Smartly bechein",
  let_get_you_started: "Chaliye shuru karte hain",
  verify_your_otp: "Apna OTP verify karen",
  select_contact: "Contact select karen",
  choose_voucher_type: "Voucher ki qisam choose karen",
  sell_voucher: "Voucher bechein",
  voucher_details: "Voucher ki details",
  no_transactions_yet: "Abhi tak koi transaction nahi",
  Youll_see_your_all:
    "Yahan apki tamam paisa aaya aur paisa gaya transaction history nazar ayegi",
  quicksale: "Quick sale",
  quick_sale_report: "Quick sale report",
  create_quick_sale: "Quick sale banayein",
  sale_amount: "Sale amount",
  edit_quicksale: "Quick sale edit karen",
  quickSale_has_been_successfully_updated:
    "Quick Sale successfully update ho gaya hai",
  quickSale_has_been_successfully_recorded:
    "Quick Sale successfully record ho gaya hai",
  are_you_sure_you_want_to_delete_this_sale:
    "Kya aap is sale record ko delete karna chahte hain?",
  discard_quick_sale_btn: "Ji haan, is quick sale ko discard karen",
  total_paid_sales: "Total paid sales",
  total_unpaid_sales: "Total unpaid sales",
  search_by_sale_id: "Sale # se search karen",
  sale_id: "Sale ID",
  delete_sale: "Sale delete karen",
  lost_in_your_quickSales: "Apni Sales mein uljh gaye?",
  OTP_verification_required: "OTP verification zaroori hai",
  You_cant_leave_otp_verify_message:
    "Aap OTP verify kiye baghair is page se nahi ja saktay.",
  sale_date_time: "Sale ki date aur time",
  select_company_or_customer: "Company ya customer select karen",
  customer_company: "Company / Customer ",
  recieved_amount: "Mili hui paise",
  recieved: "Mila",
  transaction_will_be_added_to_sales_and_contact: "Transaction sales aur contact mein shaamil ho jayegi.",
  upload_attachment: "Attachment upload karen",
  collect_payment_via_QR_or_bank_transfer: "QR ya bank transfer se payment collect karen. 100% free",
  view_qr: "QR dekhein",
  one_click_sale_faster_transaction: "One-click sale, tez transaction",
  speed_up_sales_reduce_wait_times: "Sale tez karen, wait time kam karen, aur zyada contacts ko serve karen. Roz mara ki quick sale ke liye behtareen.",
  add_quick_sale: "Quick sale add karen",
  export: "Export",
  mark_as_paid: "Paid mark karen",
  receipt: "receipt",
  quick_expense: "Quick expense",
  add_quick_expense: "Quick expense add karen",
  lost_in_expenses_stay_organized: "Expenses mein uljh gaye? Organized rahein",
  record_expense_as_soon_as: "Expense hotay hi record karen takay kuch bhi bhoolen na.",
  record_new_quick_sale: "Naya quick sale record karen",
  download_bill: "Bill download karen",
  collect: "Collect karen",
  category_pl_tracking: "Category (P&L tracking)",
  select_sales_category: "Sales category select karen",
  scan_or_share_QR_to_collect_payment: "Payment collect karne ke liye QR scan ya share karen",
  get_qr: "QR hasil karen",
  add_line_item: "Line item add karen",
  make_payment_with_bank_transfer: "Bank transfer se payment karen. 100% free.",
  paid_on: "Ada shuda tareekh",
  unit_price: "Unit price",
  start_creating_your_first_sale_invoice: "Asaan steps mein apna pehla sale invoice banana shuru karen",
  memo: "Memo",
  add_memo_here: "Yahan memo add karen",
  back: "Wapas",
  remaining_amount: "Baqaya paise",
  received_amount: "Mili hui paise",
  PO_number: "PO number",
  select_a_contact: "Contact select karen",
  bank_account_details: "Bank account ki details",
  secure_100_free: "100% secure. 100% free.",
  ref_no: "Ref no.",
  are_you_sure_you_want_to_delete_invoice: "Kya aap yeh invoice delete karna chahte hain?",
  are_you_sure_you_want_to_delete_transaction: "Kya aap yeh transaction delete karna chahte hain?",
  start_your_account_by_adding_contact: "Contact add karke apne accounts shuru karen",
  account_help_you_track: "Accounts se pata chalta hai kon apka udhaar dega aur apko kisay dena hai.",
  do_you_want_to_delete_associated_invoice: "Kya aap is contact se juri invoices delete karna chahte hain?",
  add_transaction: "Transaction add karen",
  track_the_matter_of_you_took_money_or_gave_money: "Is contact ko diye ya is se liye gaye paison ka balance track karen.",
  payment_received: "Payment mil gayi",
  no_transactions_matching_those_filters: "In filters se koi transaction match nahi hui",
  try_adjusting_filters: "Filters adjust karen ya",
  reset_small: "reset",
  you_wont_be_able_to_change_it_later: "Aap ise baad mein change nahi kar sakein ge.",
  account_settled: "Account settle ho gaya",
  create_purchase_order: "Purchase order banayen",
  purchase_order: "Purchase order",
  start_creating_your_fist_purchase_order_with_easy_steps: "Asaan steps mein apna pehla purchase order banana shuru karen",
  download_po: "PO download karen",
  PO_no: "PO no",
  edit_purchase_order: "Purchase order mein tabdeeli karen",
  add_notes_here: "Yahan notes add karen",
  notes: "Notes",
  reference_number: "reference number",
  search_by_reference_number: "Reference number se search karen",
  accept_payments_into_your_bank_account: "Apne bank account mein payments accept karen",
  add_signature_on_invoice: "Invoice per signature add karen",
  get_your_bank_details: "Apni bank details hasil karen",
  overdue: "Overdue",
  outstanding: "Baqaya",
  type_signature: "Signature type karen",
  activate_wallet: "Wallet activate karen",
  wholesale: "Wholesale",
  batchAndExpiry: "Batch aur expiry",
  no_customers_yet: "Abhi tak koi customer nahi",
  you_have_not_added_any_customer: "Aapne abhi tak koi customer add nahi kiya. Milne wale paison ko track karne ke liye customer add karen.",
  no_suppliers_yet: "Abhi tak koi supplier nahi",
  add_suppliers_to_track_payments: "Apko jo payments karni hain unhein track karne ke liye suppliers add karen.",
  no_transactions_for_others_yet: "Abhi tak doosron ki koi transaction nahi",
  when_someone_record_a_transaction_using_your_contact_details: "Jab koi apki contact details se transaction record karega, yeh yahan khud b khud aa jayegi.",
  items_imported: "Items import ho gaye",
  create_search_term_as_new_contact: "'{name}' ko naya contact banayen",
  inventory_management: "Inventory management",
  create_items_in_easy_steps_and_manage_inventory: "Asaan steps mein item banayen aur inventory manage karen.",
  sell_price: "Bechne ki price",
  current_qty: "Mojooda qty",
  stock_in_qty: "Stock in ki qty",
  stock_out_qty: "Stock out ki qty",
  units_sold: "Bike hue units",
  total_cost: "Total cost",
  see_more: "Aur dekhein",
  no_stock_history_yet: "Abhi tak koi stock history nahi",
  stock_changes_will_appear_here_one_you_start_adding: "Jab aap items add ya update karna shuru karen ge to stock changes yahan nazar aayen gy.",
  transaction_added_by_this_contact_will_appear_here_automatically: "Is contact ki add ki gayi transactions yahan khud b khud nazar aayen gi.",
  quick_sale: "Quick sale",
  sale_invoice: "Sale invoice",
  all_your_sales_in_one_place: "Apki tamam sales aik hi jaga",
  manage_all_your_quick_sale_invoices_and_pos_transactions: "Apni tamam Quick Sale, Invoice, aur POS transactions aik hi list mein manage karen.",
  businessoverview: "Business overview",
  add_expense: "expense add karen",
  Add_salesexpenses_to_see_your_PL_and_grow_your_profits: "Apna P&L dekhne aur profit barhane ke liye sales aur expenses add karen.",
  viewPAndL: "p&l dekhein",
  add_stock: "Stock add karen",
  sale_has_been_successfully_updated: "Sale kamyabi se update ho gayi.",
  profit_Loss: "Profit & Loss",
  cash_flow: "Cash flow",
  total_cost_value: "Total cost value",
  cash_Bank: "Cash & Bank",
  total_item_in_stock: "Stock mein total items",
  low_stock_items: "Low stock items",
  receivables: "Receivables",
  payables: "Payables",
  see_details: "Details dekhein",
  too_many_walk_ins_keep_them_smooth_with_pos: "Zyada walk-in customers? POS se sab kuch smooth rakhein",
  start_pos: "pos shuru karen",
  cost_of_sales: "Cost of sales",
  gross_profit: "Gross profit",
  categories: "Categories",
  see_less: "Kam dekhein",
  recent_transactions: "Halia transactions",
  gross_cash_inflow: "Gross cash inflow",
  gross_cash_outflow: "Gross cash outflow",
  net_cash_change: "Net cash change",
  change_category: "Category change karen",
  sales_category: "Sales category",
  category_updated: "Category update ho gayi",
  organize_your_expenses: "Apne expenses organize karen",
  organize_your_sales: "Apni sales organize karen",
  manage_your_Saddar_store_inventory_and_look_after_the_payments: "Apne Saddar store ki inventory manage karen aur payments ka khayal rakhein.",
  contact_attached_successfully: "Contact kamyabi se attach ho gaya",
  debit: "Debit",
  no_ledger_matching_those_filters: "In filters se koi ledger match nahi hui",
  clear_all_items: "Tamam items clear karen",
  add_to_sale: "Sale mein add karen",
  search_by_customer_name_or_sale_id: "Customer ka naam ya order number se search karen",
  order_number: "Order number",
  Variation: "Variation",
  create_item_in_easy_steps_and_manage_stock: "Asaan steps mein item banayen aur stock manage karen.",
  mark_in_stock: "In stock mark karen",
  mark_out_of_stock: "Out of stock mark karen",
  change_language: "Language change karen",
  select_language: "Language select karen",
  change_appearance: "Appearance change karen",
  select_theme: "Theme select karen",
  light_mode: "Light mode",
  dark_mode: "Dark mode",
  delete_business: "Business delete karen",
  edit_profile: "Profile mein tabdeeli karen",
  confirmation: "Confirmation",
  no_order_matching_those_filters: "In filters se koi order match nahi hua",
  pin: "Pin",
  it_ensure_that_no_one_else_can_access: "Yeh yaqeeni banata hai ke koi aur apke account tak nahi pohanch sakta",
  create_your_new_pin: "Naya PIN banayen",
  confirm_your_new_pin: "PIN confirm karen",
  enter_current_pin: "Mojoda PIN enter karen",
  please_enter_your_4_digits_PIN_to_contine: "Jari rakhne ke liye apna 4 digit PIN enter karen",
  your_accounts_first_line_of_defence_make_sure_its_unique: "Apke account ki pehli hifazat ki line. Yaqeeni banayen ke yeh unique aur guess karna mushkil ho.",
  pin_updated_successfully: "PIN kamyabi se update ho gaya",
  profile_updated: "Profile update ho gaya",
  business_created: "Business ban gaya",
  create_business: "Business banayein",
  variant_image: "Variant image",
  view: "Dekhein",
  setup_your_printer: "Apna printer setup karen",
  download_applications: "Applications download karen",
  printer_selection: "Printer selection",
  test_printer: "Printer test karen",
  to_setup_printer_download_java: "Printer setup karne ke liye Java download aur install karen",
  download_java: "Java download karen",
  watch_video_for_help: "Madad ke liye video dekhein",
  need_help_contact: "Madad chahiye? +92 341 1141000",
  test_selected_printer: "Select kiya gaya printer test karen",
  printer_setup_successfully: "Printer kamyabi se setup ho gaya",
  proceed: "Aage barhein",
  select_printer: "Printer select karen",
  printers: "Printers",
  add_another_printer: "Aik aur printer add karen",
  printer_name: "Printer ka naam",
  connected: "Connected",
  not_connected: "Connected nahi",
  connect: "Connect karen",
  disconnect: "Disconnect karen",
  is_java_application_successfully_installed: "Kya Java application kamyabi se install ho gayi hai?",
  is_printer_software_successfully_installed: "Kya printer software kamyabi se install ho gaya hai?",
  is_printer_software_drivers_successfully_installed: "Kya printer software drivers kamyabi se install ho gaye hain?",
  is_printer_test_successful: "Kya printer test kamyab raha?",
  please_select_a_printer: "Baraye meherbani aik printer select karen",
  failed_to_connect_printer_please_try_again: "Printer connect nahi ho saka. Dobara koshish karen.",
  download_and_install_printer_software: "Printer software download aur install karen",
  download_and_install_drivers: "Drivers download aur install karen",
  download_software: "Software download karen",
  download_drivers: "Drivers download karen",
  test_print: "Test Print karen",
  need_help: "Madad chahiye?",
  upload: "Upload karen",
  chat_with_us: "Chat karen",
  your_data_backup_is_up_to_date: "Apka data backup up to date hai",
  your_data_backup_is_not_up_to_date: "Apka data backup up to date nahi hai",
  error: "Error",
  enter_your_business_details: "Business details enter karen",
  enter_your_business_name: "Apne business ka naam enter karen",
  create_and_send_invoices: "Invoices banayen aur bhejein",
  create_send_and_track_invoices_Get_paid_faster: "Invoices banayen, bhejein aur track karen. Jaldi payment payen.",
  manage_your_accounts: "Apne accounts manage karen",
  track_money_in_and_out_Faster_collections_100reliable: "Paison ka aana jaana track karen. Tez collection. 100% reliable.",
  collect_send_and_earn_money: "Paisay collect karen, bhejein, aur kamayen",
  your_trusted_wallet_100_secure_completely_free: "Apka bharosemand wallet. 100% secure. Bilkul free.",
  stock_quantity: "Stock quantity",
  skip: "Skip",
  what_would_you_like_to_start: "Aap kis tarah shuru karna chahen ge?",
  scan_download_app: "Scan karen aur App download karen",
  select_unit_type: "Unit type select karen",
  sr_no: "Sr no.",
  backup_your_data: "Apna data backup karen",
  no_option: "Koi option nahi",
  is_your_printer_not_in_the_list: "Kya apka printer list mein nahi hai? Java, printer software, aur printer driver install karen, phir is per click karen",
  log_out: "Log out karen",
  loss: "Loss",
  net_loss: "Net loss",
  uncategorized: "Uncategorized",
  no_uncategorized_transactions: "Koi uncategorized transaction nahi",
  all_sales_and_expenses_are_categorized: "Tamam expense aur sales categorize ho chuke hain. Sab kuch organized rakhne per shabash!",
  create_an_account: "Account banayen",
  login_to_rupin: "RUPIN mein login karen",
  log_in: "Log in karen",
  welcome_to: "Khush amdeed",
  change_phone_number: "Phone number change karen",
  advance_paid: "Advance ada shuda",
  you_are_currently_offline: "Aap is waqt offline hain",
  please_check_your_internet_connection_and_try_again: "Apna internet connection check karen aur dobara koshish karen.",
  send_code: "code bhejein",
  verify_captcha: "Captcha verify karen",
  too_many_incorrect_attempts: "Bohat zyada ghalat PIN attempts",
  pin_entry_has_been_temporarily_locked_after_3_incorrect_attempts: "Apki security ky liye, 3 ghalat attempts ky baad PIN entry temporarily lock kar di gayi hai.",
  Youve_reached_the_8_transactions_limit: "Aap 8 transactions ki limit tak pohnch gaye hain. RUPIN mehfooz tareeqy se istemal karne ky liye apna phone number verify karen.",
  You_reached_your_limit: "Aap apni limit tak pohnch gaye hain",
  payment_received_added: "Payment received add ho gayi",
  unified_view_of_quick_sale_invoice_and_pos: "Quick sale, invoice aur POS ka ek hi view",
  account_locked: "Account lock hai",
  expense_category: "Expense category",
  select_expense_category: "Expense category select karen",
  select_due_date: "Due date select karen",
  start_typing_to_create_one: "Naya banane ky liye type karna shuru karen",
  select_purchase_category: "Purchase category select karen",
  add_signature_on_purchase_order: "Purchase order per signature add karen",
  purchase_no: "Purchase no",
  unsupported_file_format: "File format support nahi karta",
  this_customer_entry_will_be_transferred_to_the_supplier_section: "Is customer ki entry supplier section mein transfer ho jaye gi.",
  this_supplier_entry_will_be_transferred_to_the_customer_section: "Is supplier ki entry customer section mein transfer ho jaye gi.",
  we_need_your_current_pin_to_proceed: "Age barhne ky liye humein apka mojooda PIN chahiye.",
  profits: "Munafa",
  profit_Loss_statement: "Profit & Loss statement",
  net_cash: "Net cash",
  account_temporarily_locked: "Account temporarily lock hai",
  invoice_created_with_rupin: "Invoice RUPIN ky sath banaya gaya",
  po_created_with_rupin: "PO RUPIN ky sath banaya gaya",
  go_to_listing: "Listing per jayen",
  invoice_details: "Invoice ki tafseel",
  purchase_order_details: "Purchase order ki tafseel",
  record_new_quick_expense: "Naya quick expense record karen",
  account_temporarily_locked_OTP_desc: "Apki security ky liye, ye account kayi ghalat OTP attempts ky baad temporarily lock kar diya gaya hai. Access wapis hasil karne ky liye, humse rabta karen",
  account_temporarily_locked_PIN_desc: "Apki security ky liye, ye account kayi ghalat PIN attempts ky baad temporarily lock kar diya gaya hai. Access wapis hasil karne ky liye, Udhaar Book app istemal kar ke apni identity verify karen.",
  order_saved_into_draft_sales: "Order draft sales mein save ho gaya",
  add_contact_and_items_to_send_money: "Paise bhejne ky liye contact aur items add karen",
  amount_required_to_send_money: "Paise bhejne ky liye amount zaroori hai",
  go_to_home: "Home per jayen",
  the_page_you_are_looking_for_may_be_moved_or_deleted: "Jo page aap dhoond rahe hain wo move ya delete ho chuka ho sakta hai.",
  item_image: "Item ki tasveer",
  money: "Money",
  report_download_is_not_available_yet: "Report download abhi dastiyaab nahi hai.",
  something_went_wrong: "Kuch ghalat ho gaya",
  PIN_is_required: "PIN zaroori hai.",
  you_cannot_leave_this_page_without_creating_a_PIN: "PIN banaye baghair aap ye page nahi chor saktay.",
  update_item_price: "Item ka price update karen",
  udhaar_book_is_now_rupin: "Udhaar Book ab Rupin ban gaya hai.",
  migration_upgrade_subtitle: "Humne upgrade kar liya hai. Apka account bilkul waisa hi rahega.",
  migration_account_safe: "Apka account mehfooz hai",
  migration_data_secure: "Sara data mehfooz hai",
  migration_transaction_intact: "Transaction history barqarar hai",
  migration_business_records_unchanged: "Business records tabdeel nahi huye",
  continue_to_rupin: "Rupin per continue karen",
  rupin_migration_banner_message:
    "Udhaar Book ab Rupin ban gaya hai. Sab kuch mehfooz hai, nayi features aa rahi hain, bilkul muft.",
  no_vouchers: "Koi voucher nahi",
  no_bill_category: "Koi bill category nahi",
  view_statement: "Statement dekhein",
  incoming_this_month: "Is mahine ki incoming",
  outgoing_this_month: "Is mahine ki outgoing",
  view_account_limit: "Account limit dekhein",
  account_limit: "Account limit",
  increase_limit: "Limit barhayen",
  total_limit: "Total limit",
  remaining: "Baqi",
  used: "Istemal shuda",
  resets_on: "Reset hoga",
  upload_electricity_or_gas_bill_to_increase_limit: "Limit barhane ky liye electricity ya gas bill upload karen",
  upload_bill: "Bill upload karen",
  ntn_number: "NTN number",
  enter_ntn_number: "NTN number darj karen",
  ntn_number_length: "NTN number 7 se 13 digits ky darmiyan hona chahiye",
  something_went_wrong_please_try_again: "Kuch ghalat ho gaya, dobara koshish karen",
  limit_increase_is_in_process: "Limit increase process mein hai",
  limit_increase_is_in_process_subtitle: "Zaroori tafseelat submit karne ka shukriya, hum apse rabta karen gy.",
  share_qr: "Share QR",
  get_paid_faster: "Jaldi payment hasil karen",
  get_paid_faster_subtitle: "Digital invoices ky sath payments lena shuru karen",
  pay_bills: "Bills pay karen",
  enter_iban_account_raastid_name_or_phone: "IBAN, Account #, Raast ID, naam ya phone # darj karen",
  select_start_bank: "Bank select karen",
  no_banks_found: "Koi bank nahi mila",
  print_qr: "QR print karen",
  download_qr: "QR download karen",
  limit_increase_request_in_process_need_help: "Limit increase ki request process mein hai. Madad chahiye?  Hum se chat karen",
  refund: "Refund",
  select_bill_category: "Bill category select karen",
  consumer_number: "Consumer number",
  scan_barcode: "Barcode scan karen",
  results: "Results",
  last_paid: "Pichli payment",
  select_bill: "Bill select karen",
  search_bill_by_name: "Naam se bill search karen",
  no_bills_found: "Koi bill nahi mila",
  due: "Due",
  you_will_earn: "Aap kamayen gy",
  points: "points",
  bill_paid_with: "Iske zariye bill pay kiya gaya",
  rupin: "RUPIN",
  bill_paid_with_rupin: "RUPIN se bill pay kiya gaya",
  easyload_done_with: "Iske zariye easyload kiya gaya",
  easyload_done_with_rupin: "RUPIN se easyload kiya gaya",
  voucher_sent_with: "Voucher bheja gaya ba-zariya",
  voucher_sent_with_rupin: "RUPIN se voucher bheja gaya",
  failed_to_copy: "Copy nahi ho saka",
  money_sent_with: "Iske zariye paise bheje gaye",
  money_received: "Paise mile",
  money_sent: "Paise bheje gaye",
  bundle_recharge: "Easyload package",
  mins: "mins",
  other_net_mins: "Doosre network ky mins",
  all_net_sms: "Sab network ky SMS",
  money_sent_to: "Jinhe paise bheje gaye",
  money_sent_with_rupin: "RUPIN se paise bheje gaye",
  voucher_company: "Voucher company",
  select_voucher_company: "Voucher company select karen",
  search_voucher_by_name: "Naam se voucher search karen",
  no_voucher_found: "Koi voucher nahi mila",
  recent: "Haali",
  no_results_enter_complete_account_or_iban: "Koi natija nahi, mukammal account number ya IBAN darj karen",
  top_up_account_to_complete_transaction: "Is transaction ko mukammal karne ke liye apne account mein paise shamil karen.",
  search_bank: "Bank talash karen",
  error_in_send_money: "paise bhejne mein khata",
  transaction_failed: "Transaction nakam",
  your_account_has_been_locked: "Aap ka account lock ho gaya hai",
  tid: "TID",
  by: "Zariye",
  fee_free: "(Muft)",
  fast_secure_payment_in: "Tez, mehfooz adayi ",
  view_receipt: "Rasid dekhen",
  copy_receipt: "Receipt copy karen",
  network_type: "Network ki qisam",
  could_not_load_qr: "QR ki tafseel load nahi ho saki. Dobara koshish karen.",
  package_name: "Package ka naam",
  bank_statement: "Bank statement",
  last_3_months: "Pichle 3 mahine",
  last_6_months: "Pichle 6 mahine",
  last_12_months: "Pichle 12 mahine",
  request_placed: "Request bhej di gayi",
  downloading_statement: "Statement download ho rahi hai...",
  duration: "Muddat",
  easypaisa_tab: "Easypaisa",
  jazzcash_tab: "Jazzcash",
  searching: "Talaash jari hai",
  weak_pin_choose_something_else: "Kamzor PIN. Koi aur chunen",
  first_create_your_pin: "Pehle apna PIN banayen",
  others: "Others",
  add_first_transaction_for_name: "{name} ka pehla hisaab likhen",
  invoice_sale: "Invoice sale",
  attachment: "Attachment",
  paid_transactions_cannot_be_edited: "Paid transactions edit nahi ho saktin.",
  cash_book: "Cash Book",
  enter_product_name: "Product ka naam likhen",
  enter_stock: "Stock likhen",
  enter_low_stock: "Kam stock likhen",
  enter_sell_price: "Qeemat likhen",
  enter_barcode: "Barcode likhen",
  enter_wholesale_price: "Wholesale qeemat likhen",
  enter_value: "Value likhen",
  quick_item_save: "Save",
  quick_item_cancel: "Cancel",
  bulk_upload_invalid_item_name: "Item ka naam ghalat hai. Sirf letters, numbers, spaces, - ya _ istemal karen.",
  bulk_upload_item_name_missing: "CSV template mein item ka naam nahi likha gaya.",
  custom_date_range: "Custom date range",
  custom_statements: "Custom statements",
  statement_generation_started: "Aap ki statement tayyar ho rahi hai. Aap isay View statements mein dekh sakte hain.",
  no_available_statements: "Koi statement dastiyaab nahi",
  no_available_statements_subtitle: "Apke  bank statements yahan dastiyaab hote hi nazar ayen gy",
  in_progress: "Jari hai",
  cashback_on_easyload: "Easyload per cashback",
  are_you_sure_you_want_to_delete_statement: "Kya aap waqai statement delete karna chahte hain",
  channel: "Channel",
  avg_order_value: "Average order value",
  contribution: "Contribution",
  total_collected: "Total wasool shuda",
  percentage: "Percentage",
  items_sold: "Bike hue items",
  gross_sales: "Gross sales",
  net_sales: "Net sales",
  last_sold: "Aakhri dafa bika",
  current_stock: "Mojooda stock",
  cost: "Cost",
  profit_margin: "Profit margin",
  average_unit_price: "Average unit price",
  average_expense: "Average expense",
  last_purchased: "Aakhri dafa khareeda",
  cost_of_stock_sold: "Farokht hue stock ki cost",
  gross_loss: "Gross loss",
  total_discount: "Total discount",
  orders_with_discount: "Discount wale orders",
  average_discount_per_order: "Har order ka average discount",
  total_tax_collected: "Total wasool shuda tax",
  taxable_sales: "Taxable sales",
  tax_free_sales: "Tax free sales",
  multiple_tax_rates: "Mukhtalif tax rates",
  tax_rate: "Tax rate",
  tax_collected: "Wasool shuda tax",
  view_yearly_data: "Yearly data dekhein",
  no_data_yet: "Abhi tak koi data nahi",
  it_looks_like_you_dont_have_any_data_yet: "Lagta hai apne abhi tak koi transaction nahi ki.",
  start_new_sale: "Nayi sale shuru karen",
  sales_summary: "Sales summary",
  discount_summary: "Discount summary",
  expense_by_category: "Category ke hisab se expense",
  low_selling_items: "Kam bikne wale items",
  sales_by_category: "Category ke hisab se sales",
  sales_by_payment_method: "Payment method ke hisab se sales",
  tax_summary: "Tax summary",
  top_contacts_by_sale: "Sale ke hisab se top contacts",
  total_sales_by_channel: "Channel ke hisab se total sales",
  track_every_rupee: "Har rupee track karen",
  record_daily_cash_in_and_cash_out: "Rozana cash in aur cash out record karen.",
  add_category_to_track_PAndL: "P&L track karne ke liye category add karen",
  saved_successfully: "Successfully save ho gaya",
  unable_to_load_this_entry: "Yeh entry load nahi ho saki",
  activate_account: "Account activate karen",
  activate_now: "Abhi activate karen",
  add_money_from_any_bank_free: "Kisi bhi bank se paise add karen. 100 Free.",
  add_money_from_easypaisa: "Easypaisa se paise add karen",
  easypaisa_step_see_all: "'See all' per click karen",
  easypaisa_step_fee_collection: "'Fee collection' select karen",
  easypaisa_step_search_rupin: "'Rupin' search kar ke select karen",
  easypaisa_step_enter_consumer_id: "Consumer ID darj karen",
  instruction_for_adding_money: "Paise add karne ki hidayat",
  getQR: "QR hasil karen",
  enter_amount: "Amount darj karen",
  processing_limit_increase_contact_you: "Limit increase process ho rahi hai. Hum apse rabta karen gy",
  no_vouchers_available: "Koi voucher dastiyaab nahi",
  there_are_no_vouchers_available_at_the_moment: "Is waqt koi voucher dastiyaab nahi hai. Jese hi vouchers dastiyaab hongy, yahan nazar ayen gy.",
  are_you_sure_you_want_to_logout_all_data_will_be_lost: "Kya aap waqai logout karna chahte hain? Sara data zaya ho jaye ga.",
  confirm_payment: "Payment Confirm Karen",
  incorrect_reference_number: "Ghalat reference number",
  bill_image_will_appear_here: "Bill ki tasveer yahan nazar aye gi",
  reference_no: "Reference No.",
  account_no: "Account No.",
  customer_id: "Customer ID",
  instantly_check_your_bill: "Foran apna bill check karen",
  enter_bill_details_below: "Apna latest bill dekhne, pay karne aur cashback kamane ky liye neeche bill ki tafseel darj karen",
  search_bill: "Bill talash karen",
  powered_by_nadra: "Nadra ke zariye",
  licensed_by_sbp_in_principle: "SBP se licensed (usoolan)",
  trusted_by_5_3_million_users: "5.3 million+ users ka aitmaad",
  select_biller: "Biller select karen",
  your: "Aap ka",
  check_pay_bills_with_rupin: "Rupin kay sath bill check aur ada karen",
  error_message_more_than_10digits: "Error: 10 se zyada digits add nahi kar sakte",
  order_history: "Order history",
  last_trx_date: "Aakhri trx date",
  due_today: "Aaj ka baqaya",
  total_balance_due: "Total baqaya balance",
  copy_details: "Details copy karen",
  collect_from: "Yahan se collect karen",
  account_detailsbank_transfer: "QR ya bank transfer se payment collect karen. 100% free",
  show_qr: "QR dikhayen",
  copy_qr_image: "QR image copy karen",
  image_copied: "Image copy ho gayi",
  you_dont_have_any_pending_collections: "Apki koi pending collection nahi hai",
  visibility: "Visibility",
  published: "Published",
  by_others: "Doosron ki taraf se",
  method: "Method",
  newest: "Naya tareen",
  oldest: "Purana tareen",
  amount_high_to_low: "Amount (Zyada se Kam)",
  amount_low_to_high: "Amount (Kam se Zyada)",
  search: "Search",
  name_z_a: "Naam (Z-A)",
  quantity_high_to_low: "Quantity (Zyada se Kam)",
  quantity_low_to_high: "Quantity (Kam se Zyada)",
  end: "End",
  keyword: "Keyword",
  seller_central: "Seller central",
  pincode_menu_label: "Pincode",
  printer: "Printer",
  search_by: "Search by",
  something_went_wrong_fetching_transactions: "Transactions fetch karte waqt kuch ghalat hogaya",
  download_url_not_available: "Download URL available nahi hai",
  pdf_downloaded_successfully: "PDF download ho gayi",
  failed_to_download_file: "File download nahi ho saki",
  sent: "Bheja gaya",
  transfer: "Transfer",
  withdraw: "Nikalwayein",
  bill_payment_text: "Bill payment",
  voucher_payment_text: "Voucher Payment",
  rupin_cashback: "Rupin Cashback",
  sms_plan: "SMS plan",
  order_hash: "Order #",
  please_add_a_phone_number_to_continue: "Jari rakhne ke liye phone number add karen",
  bill_fetching_failed: "Bill fetch nahi ho saka",
  error_fetching_bill_transaction: "Bill transaction fetch karne mein error",
  not_paid_overdue: "Ada nahi hua (Overdue)",
  month: "Mahina",
  consumer_id: "Consumer ID",
  bills_will_appear_here_once_available: "Bills available hone par yahan nazar ayen gy",
  bill_not_found: "Bill nahi mila",
  error_fetching_bill: "Bill fetch karne mein error",
  bill_payment_failed: "Bill payment nahi ho saki",
  error_in_bill_payment: "Bill Payment mein error",
  please_add_phone_number_to_continue: "Jari rakhne ke liye phone number add karen",
  search_by_name_or_phone: "Naam ya phone se search karen",
  no_of_transactions: "Transactions ki tadad",
  try_adjusting_your_filters_or: "Filters adjust karen ya ",
  transactions_will_appear_here_once_available: "Transactions available hone par yahan nazar ayen gy",
  cashback: "Cashback",
  error_in_recharge: "Recharge mein error",
  free: "Free",
  on_net_mins: "On net Mins",
  gbs_data: "GBs data",
  all_in_one_weekly: "All-in-One Weekly",
  error_in_easyload_and_package: "EasyLoad & Package mein error",
  default_processing_time: "2.6 sec",
  open_your_bank_app_easypaisa_or_jazzcash: "Apni Bank app, Easypaisa ya Jazzcash kholein",
  tap_send_or_transfer: "'Send' ya 'Transfer' par tap karen",
  search_rupin: "Rupin search karen",
  enter_rupins_account_number_or_iban: "Rupin ka account number ya IBAN darj karen",
  easypaisa_app_send_money: "Easypaisa app (Send money)",
  open_easypaisa_app: "Easypaisa app kholein",
  tap_on_send_money: "'Send money' par tap karen",
  select_bank_transfer: "'Bank transfer' select karen",
  select_bank_rupin: "Bank 'Rupin' select karen",
  easypaisa_app_collection: "Easypaisa app (Collection)",
  tap_on_see_all: "'See all' par tap karen",
  tap_on_fee_collection: "'Fee collection' par tap karen",
  search_and_select_udhaar_app: "\"Udhaar App\" search kar k select karen",
  enter_consumer_id: "Consumer ID darj karen",
  open_jazzcash_app: "Jazzcash app kholein",
  tap_on_money_transfer: "'Money transfer' par tap karen",
  tap_on_bank_transfer: "'Bank transfer' par tap karen",
  cash_bank: "Cash/Bank",
  voucher_purchase_failed: "Voucher purchase nahi ho saka",
  error_in_buy_voucher: "Voucher lene mein error",
  voucher_transaction_failed: "Voucher transaction nahi ho saki",
  error_fetching_voucher_transaction: "Voucher transaction fetch karne mein error",
  to_lowercase: "to",
  cashback_label: "Cashback",
  bill_payment_label: "Bill payment",
  consumer_name: "Consumer ka naam",
  consumer_name_caps: "Consumer Ka Naam",
  no_of_bills: "Bills ki tadad",
  try_adjusting_your_filters: "Filters adjust karen ya ",
  attach_label: "Attach",
  to_this_transaction_confirm: "is transaction se attach karen?",
  attach_contact_confirm: "{name} ko is transaction se attach karen?",
  contact_linked_successfully: "Contact link ho gaya",
  failed_to_link_contact: "Contact link nahi ho saka",
  transaction_not_available: "Transaction available nahi hai",
  error_fetching_transaction: "Transaction fetch karne mein error",
  account_locked_contact_support: "Apka account lock hogaya hai, meharbani kar k support se raabta karen",
  previous_slide: "Pichla slide",
  next_slide: "Agla slide",
  wallet_onboarding_b_slide3_alt: "Rupin QR receive",
  wallet_onboarding_b_slide2_alt: "Support hone wale banks",
  wallet_onboarding_b_slide1_alt: "Rupin wallet",

  minimum_amount: "Kam se kam paise",
  maximum_amount: "Ziada se ziada paise",
  search_by_contact: "Contact se talash karen",
  search_by_contact_or_order_no: "Contact ya order number se talash karen",
  search_by_contact_or_invoice_no: "Contact ya invoice number se talash karen",
  invalid_number: "Ghalat number",
  cannot_be_negative: "Manfi nahi ho sakta",
  cannot_be_negative_or_zero: "Manfi ya zero nahi ho sakta",
  max_should_be_greater_than_min: "Max, min se zyada hona chahiye",
  thirty_days: "30 Din",
  half_yearly: "6 Mahine",

  fill_in_your_data: "Apna data fill karen",
  upload_the_file: "File upload karen",
  csv_xls_files_supported: "(.csv aur .xls files supported hain)",
  invalid_file_format_csv_xls: "Ghalat file format. Meharbani kar k .csv, .xls, ya .xlsx file upload karen.",
  file_uploaded: "File upload ho gayi",
  finished: "Mukammal",
  entries_imported_successfully: "entries kamyabi se import ho gayin.",
  entries_failed: "entries fail ho gayin",
  item_discount: "Item discount",
  remove_item: "Item remove karen",
  transaction_details: "Transaction ki tafseelat",

  scan_and_pay: "Scan karen aur pay karen",
  scan_qr: "QR scan karen",
  bank_transfer: "Bank transfer",
  transfer_to_this_iban: "Is IBAN par transfer karen",
  transfer_exact_amount_shown_above: "Upar dikhai gayi sahi paise transfer karen",
  how_to_pay: "Kaise pay karen",
  scan_step_1: "Apni banking app ya wallet open karen aur upar diye gaye QR code ko scan karen.",
  scan_step_2: "Amount Rs. {amount} confirm karen aur transfer karen",
  scan_step_3: "Pay par click karen.",
  bank_step_1: "Apni banking app ya wallet open karen",
  bank_step_2: "Upar diye gaye IBAN par sahi paise Rs. {amount} transfer karen",
  bank_step_3: "Pay par click karen.",
  verify_payment: "Payment verify karen",
  bill_payment_to: "Bill payment banaam",
  payment_mode: "Payment mode",
  contact_support: "Support se rabta karen",
}
